<template>
	<ion-app>
		<div id="app" :class="{'map-shown': showMap, 'not-logged-in':!isLoggedIn, 'full-screen-map':showMapFullScreen, 'side-map-shown':showSideMap, 'mobile-view': $store.state.isMobile, 'transition-period':$store.state.transitionPeriod, 'keyboard-visible':$store.state.keyboardVisible, 'keyboard-will-show':keyboardWillShow, 'keyboard-will-hide':keyboardWillHide, 'keyboard-did-show':keyboardDidShow, 'keyboard-did-hide':keyboardDidHide, 'listing-view': listingView(), 'side-pages': sidePages()}">
		<div id="transition-bar" v-if="$store.state.transitionPeriod" v-html="$store.state.transitionMessage"></div>
			<div id="nav-wrapper" v-show="isLoggedIn && checkPath()">
				<b-navbar id="nav" class="hide-mobile">
					<img src="./assets/cow.svg" alt="City Of Winnipeg" class="hide-mobile" id="cow-logo" />
					<span id="title">{{$t('header.appTitle')}}</span>
					<b-nav-item to="/lane-closure-request-list" exact v-show="isLoggedIn">
						<img src="./assets/mapicon.svg" alt="map" />
						Lane Closure Requests
					</b-nav-item>

					<b-nav-item to="/new-lane-closure-request" exact v-if="!$store.getters.isReadOnly() || $store.getters.userCanCreateRequest()" v-show="isLoggedIn">
						<img src="./assets/newicon.svg" alt="new" />
						New Lane Closure Request
					</b-nav-item>
					<b-nav-item to="/report-lane-closure" v-show="isLoggedIn">
						<img src="./assets/reportclosure.svg" alt="reportclosure" />
						Close / Re-open Lanes
					</b-nav-item>
					<b-nav-item to="/report-restriction" v-show="isLoggedIn">
						<img src="./assets/restriction.svg" alt="restriction" />
						Place / Remove Restriction
					</b-nav-item>
					<b-nav-item to="/report-contravention" v-show="isLoggedIn && canReportContravention">
						<img src="./assets/contraventions.svg" alt="contraventions" />
						Violations
					</b-nav-item>
					<b-nav-item to="/contraventions" v-show="isLoggedIn && !canReportContravention">
						<img src="./assets/contraventions.svg" alt="contraventions" />
						Violations
					</b-nav-item>
					<b-nav-item class="hide-mobile" @click="toggleMenu" :active="shouldShowMenu" id="menu-nav-item" v-show="isLoggedIn">
						<img src="./assets/menuicon.svg" alt="menu" />
						<span>Menu<img src="./assets/downarrow.svg" id="menu-downarrow" alt="downarrow" :class="{'up':showMenu}" /></span>
					</b-nav-item>

					<b-nav-item class="hide-mobile" @click="toggleProfileMenu" id="show-profile-button" v-show="isLoggedIn">
									<span class="icon-user"></span>
									<span class="profile-name" v-html="profileName"></span>
					</b-nav-item>
					<b-nav-item v-show="isLoggedIn" href="https://laneclosures.winnipeg.ca/help/index.html" target="_blank">
						<img src="./assets/lc-detail.svg" alt="help" />
						<span>Help</span>
					</b-nav-item>
				</b-navbar>
				<div class="hide-mobile">
					<b-collapse id="menu-expandable" :visible="shouldShowMenu">
						<b-container>
							<b-row>
								<b-col class="col" sm="auto">
									<div><a href="http://winnipeg.ca/publicworks/trafficControl/pdf/regionalStreetNetwork-MAP.pdf" download="regionalStreetNetwork-MAP.pdf" target="_blank"><span>Regional Street Map</span></a></div>
									<div><a href="http://winnipeg.ca/publicworks/trafficControl/manualTempTrafficControl.stm" target="_blank"><span>Manual of Temporary Traffic Control</span></a></div>
								</b-col>
								<b-col class="col" sm="auto">
									<div><a href="http://winnipegtransit.com/en/locations/find" target="_blank"><span>Transit Map </span></a></div>
									<div><a href="https://legacy.winnipeg.ca/publicworks/trafficcontrol/laneclosures/lane-closures-map.stm" target="_blank"><span>Lane Closures Map</span></a></div>
								</b-col>
								<b-col class="col" sm="auto" v-if="canOrganizationRequests() || canAuditLog() || canUserRequests()">
									<div v-if="canOrganizationRequests()"><b-link to="/admin/organization-approval-list">Organization Requests</b-link></div>
									<div v-if="canUserRequests()"><b-link to="/admin/user-approval-list">New Account Requests</b-link></div>
									<div v-if="canAuditLog()"><b-link to="/admin/audit-log-list">Audit Log</b-link></div>
								</b-col>

								<b-col class="col" sm="auto" v-if="canGlobalSettings()">
									<div v-if="canGlobalSettings()"><b-link to="/admin/global-settings" v-show="isLoggedIn">Global Settings</b-link></div>
									<div v-if="canGlobalSettings()"><b-link to="/admin/notification-schedule-list" v-show="isLoggedIn">Notifications Schedule</b-link></div>
									<div v-if="canGlobalSettings()"><b-link to="/admin/set-block-details" v-show="isLoggedIn">Set Street Directions</b-link></div>
									<div v-if="canGlobalSettings()"><b-link to="/admin/banner/edit" v-show="isLoggedIn">Edit Callout</b-link></div>
								</b-col>

							</b-row>
						</b-container>
					</b-collapse>
				</div>


				<div class="nav-primary-wrap nav-rounded-wrap" v-show="showMenuPrimary">
				<b-navbar id="nav" class="nav-bar-common mobile slide-up-menu-group">
					<b-nav-item @click="toggleSlideUpMenu($event, 'requests')" :class="{selected: slideUpMenu === 'requests' || ( ($route.name == 'LaneClosureList' || $route.name == 'home' || $route.name == 'home2' || $route.name == 'AddLaneClosureRequest')  && slideUpMenu === null) }" :active="slideUpMenu === 'requests'|| (($route.name == 'LaneClosureList' || $route.name == 'home' || $route.name == 'home2' || $route.name == 'AddLaneClosureRequest')  && slideUpMenu === null)" v-show="isLoggedIn">
						<img src="./assets/mapicon-yellow.svg" alt="reportClosure" />
						<span class="d-block" v-if="$store.state.isMobile">Requests</span>
						<span class="d-block" v-else>Lane Closure Requests {{slideUpMenu}}</span>
					</b-nav-item>
					<b-nav-item @click="toggleSlideUpMenu($event, 'closures')" :class="{selected: slideUpMenu === 'closures' || ($route.name == 'ReportClosureSearch' && slideUpMenu === null)}" :active="slideUpMenu === 'closures'|| ($route.name == 'ReportClosureSearch' && slideUpMenu === null)" v-show="isLoggedIn">
						<img src="./assets/reportclosure-yellow.svg" alt="new" />
						<span class="d-block" v-if="$store.state.isMobile">Closures</span>
						<span class="d-block" v-else>Close / Re-open Lanes</span>
					</b-nav-item>
					<b-nav-item @click="toggleSlideUpMenu($event, 'restrictions')" :class="{selected: slideUpMenu === 'restrictions' || ($route.name == 'ReportRestrictionSearch'  && slideUpMenu === null)}" :active="slideUpMenu === 'restrictions' || ($route.name == 'ReportRestrictionSearch'  && slideUpMenu === null)" v-show="isLoggedIn">
						<img src="./assets/restriction-yellow.svg" alt="restriction" />
						<span class="d-block" v-if="$store.state.isMobile">Restrictions</span>
						<span class="d-block" v-else>Place/Remove Restriction</span>
					</b-nav-item>
					<b-nav-item class="contraventions-number" @click="goToContraventionsList('with')" :class="{selected: slideUpMenu === 'contraventions' || ($route.name == 'ReportContraventionSearch'  && slideUpMenu === null)}" :active="slideUpMenu === 'contraventions'|| ($route.name == 'ReportContraventionSearch'  && slideUpMenu === null)" v-show="isLoggedIn" v-if="!canReportContravention">
						<img src="./assets/contraventions-yellow.svg" alt="violations" />
						<b-badge class="d-inline" v-if="violationCount > 0">{{ violationCount }}</b-badge> Violations
					</b-nav-item>
					<b-nav-item class="contraventions-number" @click="toggleSlideUpMenu($event, 'contraventions')" :class="{selected: slideUpMenu === 'contraventions'|| ($route.name == 'ReportContraventionSearch'  && slideUpMenu === null)  || ($route.name == 'AddLaneClosureRequestWithContravention'  )}" :active="slideUpMenu === 'contraventions'|| ($route.name == 'ReportContraventionSearch'  && slideUpMenu === null) || ($route.name == 'AddLaneClosureRequestWithContravention'  )" v-show="isLoggedIn" v-else>
						<img src="./assets/contraventions-yellow.svg" alt="violations" />
						Violations
					</b-nav-item>
					<b-nav-item v-if="false" @click="toggleSlideUpMenu($event, 'menu')" :active="slideUpMenu === 'menu' && shouldShowMenu" id="menu-nav-item" v-show="isLoggedIn">
						<img src="./assets/menuicon.svg" alt="menu" />
						Menu
					</b-nav-item>
				</b-navbar>
				</div>

				<div class="nav-rounded-wrap" v-show="showMenuRequest">
				<b-navbar id="nav" class="nav-bar-request mobile slide-up-menu-group">
					<b-nav-item @click="toggleSlideUpMenu($event, 'report')" :class="{selected: (slideUpMenu === 'report' || $route.name === 'ReportClosure'  || $route.name === 'ReportRestriction' || $route.name === 'ReportContravention') , navItemReport:true}" :active="(slideUpMenu === 'report' || $route.name === 'ReportClosure'  || $route.name === 'ReportRestriction'  || $route.name === 'ReportContravention'  )" v-show="isLoggedIn">
						<b-img src="/img/nav/icon-report.svg"></b-img>
						<span class="d-block">Report</span>
					</b-nav-item>

					<b-nav-item v-if="canMarkAsCompleted" @click="markAsCompleted()" class="navItemCompleted">
						<b-img src="/img/nav/icon-mark-completed.svg"></b-img>
						<span class="d-block" v-html="getMarkAsCompletedText">Mark as Completed</span>
					</b-nav-item>
					<b-nav-item v-if="!canMarkAsCompleted" @click="doNothing()" class="navItemCompleted">
						<b-img src="/img/nav/icon-mark-completed.svg"></b-img>
						<span class="d-block" v-html="getCannotMarkAsCompletedText">Mark as Completed</span>
					</b-nav-item>

						<b-nav-item @click="toggleSlideUpMenu($event, 'viewRequest')" :class="{selected: (slideUpMenu === 'viewRequest' || $route.name === 'LaneClosureRequestActivity' || $route.name === 'LaneClosureRequestActivityCacheBuster'  || $route.name === 'LaneClosureRequestContraventions' || $route.name === 'LaneClosureRequestContraventionsCacheBuster' || $route.name === 'LaneClosureRequestAttachments' || $route.name === 'LaneClosureRequestAttachmentsCacheBuster' || $route.name === 'ViewLaneClosureRequest' || $route.name === 'ViewLaneClosureRequestCacheBuster' || $route.name === 'EditContravention') , navItemViewRequest:true}" :active="(slideUpMenu === 'viewRequest' || $route.name === 'LaneClosureRequestActivity' || $route.name === 'LaneClosureRequestActivityCacheBuster'  || $route.name === 'LaneClosureRequestContraventions' || $route.name === 'LaneClosureRequestContraventionsCacheBuster' || $route.name === 'LaneClosureRequestAttachments' || $route.name === 'LaneClosureRequestAttachmentsCacheBuster' || $route.name === 'ViewLaneClosureRequest' || $route.name === 'ViewLaneClosureRequestCacheBuster' || $route.name === 'EditContravention')" v-show="isLoggedIn">
						<b-img src="/img/nav/icon-information.svg"></b-img>
						<span class="d-block">View</span>
					</b-nav-item>
					<b-nav-item @click="toggleSlideUpMenu($event, 'actionRequest')" :class="{selected: ( slideUpMenu === 'actionRequest'  ||  $route.name === 'EditLaneClosureRequest'), navItemActionRequest:true}" :active="( slideUpMenu === 'actionRequest'  ||  $route.name === 'EditLaneClosureRequest')" v-show="isLoggedIn">
						<b-img src="/img/nav/icon-actions.svg"></b-img>
						<span class="d-block">Actions</span>
					</b-nav-item>
					<b-nav-item v-if="false" @click="toggleSlideUpMenu($event, 'menu')" :active="slideUpMenu === 'menu' && shouldShowMenu" id="menu-nav-item" v-show="isLoggedIn">
						<img src="./assets/menuicon.svg" alt="menu" />
						Menu
					</b-nav-item>
				</b-navbar>
				</div>


				<div class="nav-rounded-wrap" v-show="showMenuRequestedChanges">
					<b-navbar id="nav" class="nav-bar-requested-changes mobile slide-up-menu-group">

						<b-nav-item @click="onActionRequestedChangesMenu('actionRequestedChangesBack')" class="navItemBackToApproved">
							<b-img src="/img/nav/icon-back-to-approved.svg"></b-img>
							<span class="d-block">Back To Approved</span>
						</b-nav-item>
						<b-nav-item v-show="hasChangesRequested()"  @click="onActionRequestedChangesMenu('actionRequestedChangesEdit')" class="navItemRequestedChangesEdit">
							<b-img src="/img/nav/icon-edit-requested-changes.svg"></b-img>
							<span class="d-block">Edit Changes</span>
						</b-nav-item>
						<b-nav-item v-show="!hasChangesRequested()"  @click="onActionRequestedChangesMenu('actionRequestedChangesEdit')" class="navItemRequestedChangesEdit">
							<b-img src="/img/nav/icon-edit-requested-changes.svg"></b-img>
							<span class="d-block">Request Changes</span>
						</b-nav-item>
						<b-nav-item v-show="hasChangesRequested()" @click="onActionRequestedChangesMenu('actionRequestedChangesDiscard')" class="navItemRequestedChangesDiscard">
							<b-img src="/img/nav/icon-discard-requested-changes.svg"></b-img>
							<span class="d-block">Discard Changes</span>
						</b-nav-item>
					</b-navbar>
				</div>


			</div>
			<div>
				<div class="lc-overlay"></div>
				<Slide :is-open="shouldShowMenu" :class="{'side-menu-opened':shouldShowMenu}" right id="side-menu" @closeMenu="OnSideMenuClose" :burgerIcon="false" :disableOutsideClick="disableSideMenuOutsideClickWindow || disableSideMenuOutsideClickMenu">
					<div class="sidemenu-header">
					<img @click="secretTesting" src="@/assets/cow.svg" alt="City Of Winnipeg" id="sidemenu-cow-logo" />
					</div>
					<router-link to="/my-notifications" v-on:click.native="clickSideMenuLink"><span>Notification Settings</span></router-link>
					<router-link to="/my-settings" v-on:click.native="clickSideMenuLink"><span>Account</span></router-link>
					<router-link to="/admin/user-list" v-on:click.native="clickSideMenuLink"><span>Users</span></router-link>
					<router-link to="/admin/organization-list" v-on:click.native="clickSideMenuLink"><span>Organization</span></router-link>
					<router-link v-if="canUserRequests()" to="/admin/user-approval-list" v-on:click.native="clickSideMenuLink"><span>User Requests</span></router-link>
					<router-link v-if="canOrganizationRequests()" to="/admin/organization-approval-list" v-on:click.native="clickSideMenuLink"><span>Organization Requests</span></router-link>
					<router-link v-if="canGlobalSettings()" to="/admin/global-settings" v-show="isLoggedIn" v-on:click.native="clickSideMenuLink"><span>Global Settings</span></router-link>
					<router-link v-if="canGlobalSettings()" to="/admin/banner/edit" v-show="isLoggedIn" v-on:click.native="clickSideMenuLink"><span>Edit Callout</span></router-link>
					<router-link v-if="canAuditLog()" to="/admin/audit-log-list" v-on:click.native="clickSideMenuLink"><span>Audit Log</span></router-link>
					<a href="http://winnipeg.ca/publicworks/trafficControl/pdf/regionalStreetNetwork-MAP.pdf" download="regionalStreetNetwork-MAP.pdf" target="_blank" v-on:click="clickSideMenuLink"><span>Regional Street Map</span></a>
					<a href="http://winnipeg.ca/publicworks/trafficControl/manualTempTrafficControl.stm" target="_blank" v-on:click="clickSideMenuLink"><span>Manual of Temporary Traffic Control</span></a>
					<a href="http://winnipegtransit.com/en/locations/find" target="_blank" v-on:click="clickSideMenuLink"><span>Transit Map </span></a>
					<a href="https://legacy.winnipeg.ca/publicworks/trafficcontrol/laneclosures/lane-closures-map.stm" target="_blank" v-on:click="clickSideMenuLink"><span>Lane Closures Map</span></a>
					<a href="https://laneclosures.winnipeg.ca/help/index.html" target="_blank"><span>Help</span></a>
					<a href="#" @click="logout"><span>Logout</span></a>
				</Slide>
			</div>


			<div id="main" :class="mainClasses()">
				<div class="page-nav-mobile-placeholder">
					<div :class="{'page-nav-mobile-wrapper':true}" class="mobile-header-menu">
						<b-container class="page-nav-container">
							<b-nav small class="page-nav-mobile">
								<li class="nav-item no-border">&nbsp;</li>
							</b-nav>
						</b-container>
					</div>
				</div>
				<div class="page-nav-mobile-container" v-show="shouldShowPageNav()">
					<page-nav-mobile
					:unreadMessagesCount="messageNotificationsCount"
					:unreadUpdatesCount="updateNotificationsCount"
					v-on:lanefilters:togglemessages="toggleMessages"
					v-on:lanefilters:toggleupdates="toggleUpdates"
					ref="pageNavMobileRef"
				/></div>
				<div class="main__router-view-wrapper" :class="{'showing-mobile-page-nav':shouldShowPageNav()}">
					<router-view ref="myRouterView" :key="$route.fullPath" />
					<v-popover></v-popover>
				</div>
			</div>
				<transition name="slide-fade" tag="div">
			<div id="vue-map-wrapper" :class="{'vue-map-wrapper':true, 'full-screen':showMapFullScreen, 'section-slide-panel':true}" v-show="showMap">
				<div class="map-side-panel" v-html="infoWindowHtml">
				</div>
				<div v-show="isLoadingMap" class="map-loading"><b-spinner small label="Loading other requests..." class="ml-2"></b-spinner></div>

						<div class="map-filter">
					<div class="d-flex">

						<div><button class="map-filter__close" size="sm" text="Button" @click="onHideMap"><img src="./assets/cross.svg" alt="Close Map" /></button></div>
						<div class="flex-grow-1" style="position:relative;">
							<multiselect
								class="custom-multiselect map-street-search"
								ref="mapAutocompleteRef"
								v-model="mapSearchStreet"
								track-by="id"
								open-direction="bottom"
								label="label"
								:options="mapStreetOptions"
								:show-labels="false"
								:multiple="false"
								:close-on-select="true"
								:hide-selected="false"
								:preserve-search="false"
								:clear-on-select="false"
								:internal-search="false"
								placeholder="Select or start typing"
								:loading="isMapStreetsLoading"
								@search-change="debounceStreetSearch"
								@select="onMapStreetInput"
							>
								<template slot="selection" slot-scope="{ values, search, isOpen }">
									<span
										class="multiselect__single"
										v-if="values.length && !isOpen"
										v-html="getOptionSelected(values.length)"
									></span>

								</template>
								<template slot="option" slot-scope="props">
									<div class="option__desc">
										<span class="option__title">{{ props.option.label }}</span><br>
									</div>
								</template>
								<template slot="noOptions">
								</template>
								<template slot="afterList">
									<li class="multiselect__after-list">Start typing to find streets.</li>
								</template>

								<template slot="noResult">
									No results. Please try changing the search query.
								</template>
							</multiselect>


							<button v-show="hasMapSearchTerms" type="button" class="map-filter__autocomplete-clear" text="Clear" variant="primary" @click="onClearPlace"><img src="./assets/cross.svg" alt="Clear Location" /></button>
						</div>
						<div class="pt-3" v-if="false">
						          <date-range-picker
						              v-model="filterDate"
						              show-dropdowns
						              opens="center"
						              @update="onDateRangeSelect"
						              :ranges="dateRangePickerRanges"
						              :auto-apply="true"
							:append-to-body="$store.state.isMobile"
						          >
						          <template v-slot:input="picker" style="min-width: 350px;">
						              <span v-if="picker.startDate && picker.endDate" v-html="formatDateRange(picker.startDate,picker.endDate)">
						              </span>
						              <span v-else>Start/End Date</span>
						          </template>
						        </date-range-picker>

						</div>
						<!-- <div class=""><b-button text="Button" variant="primary" @click="onClearPlace">Clear</b-button></div> -->
						<!-- <div><b-button text="Button" variant="primary" @click="onCenterMap">Center</b-button></div> -->
						<div id="popover-wrapper">
							<b-button text="Button" variant="primary" id="google-map-legend-btn">Legend</b-button>

						</div>



						<div v-if="1 == 2">

							<b-dropdown id="map-date-range-dd" variant="primary" class="" text="Filter">
								<b-dropdown-form>
									<b-form-group >
										<b-form-checkbox v-model="showNearby" value="true" class="mb-3" style="white-space:nowrap"><span>Show Nearby Requests</span></b-form-checkbox>
									</b-form-group>

									<b-form-group >
										<b-form-select v-model="filterMapDateBy" :options="filterMapDateByOptions"></b-form-select>
									</b-form-group>

								</b-dropdown-form>
								<b-dropdown-form>

									<b-form-group id="ig-equest-start-date" label="From" label-for="filter-map-start-date" :state="mapFromDate.status" :invalid-feedback="mapFromDate.invalidMessage">
										<date-picker bootstrap-styling id="filter-map-start-date" format="MM/dd/yyyy" v-model="mapFromDate.value" :input-class="{'is-invalid': mapFromDate.status == false}" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
									</b-form-group>
									<b-form-group id="ig-equest-start-date" label="To" label-for="filter-map-end-date" :state="mapToDate.status" :invalid-feedback="mapToDate.invalidMessage">
										<date-picker bootstrap-styling id="filter-map-end-date" format="MM/dd/yyyy" v-model="mapToDate.value" :input-class="{'is-invalid': mapToDate.status == false}" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
									</b-form-group>
									<b-form-group>
										<b-button type="button" variant="primary" @click="onFilterMap">Reload Map <b-spinner small label="Loading..." class="ml-2" v-if="isLoadingMap"></b-spinner></b-button>
									</b-form-group>
								</b-dropdown-form>

							</b-dropdown>
						</div>
					</div>
<!-- 				<div class="map-block-picker-hint" :v-show="showBlockPicker">
								Add or remove blocks by clicking on the map.
							</div> -->
						</div>

						<GmapMap class="map-canvas" ref="mapRef" :center="{lat:49.895077, lng:-97.138451}" :zoom="30" map-type-id="terrain" :options="{
						zoomControl:true,
						mapTypeControl:true,
						scaleControl:true,
						streetViewControl:true,
						rotateControl: true,
						fullscreenControl:false,
						disableDefaultUi: false
					}" @click="onMapClick" >
				</GmapMap>
			</div>
		</transition>
			<!-- Lane Closure Requests -->
			<SlideUpMenu class="mobile-only primary-slide-up-menu" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onStatusUpdate" :menuProp="{lists: $store.getters['laneClosureList/getTotals'] ? $store.getters['laneClosureList/getTotals'].requests : {}, active: 'requests' === slideUpMenu, index:'requests'}" />
			<!-- Close / Re-open Lanes -->
			<SlideUpMenu class="mobile-only primary-slide-up-menu" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onStatusUpdate" :menuProp="{lists: $store.getters['reportClosureList/getTotals'] ? $store.getters['reportClosureList/getTotals'].closures : {}, active: 'closures' === slideUpMenu, index:'closures'}" />
			<!-- Place / Remove Restriction -->
			<SlideUpMenu class="mobile-only primary-slide-up-menu" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onStatusUpdate" :menuProp="{lists: $store.getters['reportRestrictionList/getTotals'] ? $store.getters['reportRestrictionList/getTotals'].restrictions : {}, active: 'restrictions' === slideUpMenu, index:'restrictions'}" />
			<!-- Contraventions -->
			<SlideUpMenu class="mobile-only primary-slide-up-menu" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onStatusUpdate" :menuProp="{lists: $store.getters['reportContraventionList/getTotals'] ? $store.getters['reportContraventionList/getTotals'].contraventions : {}, active: 'contraventions' === slideUpMenu, index:'contraventions'}" />

			<!-- View Request Screens -->
			<SlideUpMenu class="mobile-only" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onViewRequestMenu" :menuProp="{lists:  {me:1}, active: 'viewRequest' === slideUpMenu, index:'viewRequest'}" />

			<!-- View Request Actions -->
			<SlideUpMenu class="mobile-only" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onActionRequestMenu" :menuProp="{lists:  {me:1}, active: 'actionRequest' === slideUpMenu, index:'actionRequest'}" />


			<!-- View Request Screens -->
			<SlideUpMenu class="mobile-only" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onViewRequestedChangesMenu" :menuProp="{lists:  {me:1}, active: 'viewRequestedChanges' === slideUpMenu, index:'viewRequestedChanges'}" />

			<!-- View Request Actions -->
			<SlideUpMenu class="mobile-only" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onActionRequestedChangesMenu" :menuProp="{lists:  {me:1}, active: 'actionRequestedChanges' === slideUpMenu, index:'actionRequestedChanges'}" />



			<!-- Report Closure / Restriction -->
			<SlideUpMenu class="mobile-only" v-on:toggle:menu="slideUpMenu = null" v-on:callback="onReportMenu" :menuProp="{lists:  {me:1}, active: 'report' === slideUpMenu, index:'report'}" />



			<b-modal centered ref="modal-under-development" :title="modalTitle">{{modalBody}}</b-modal>
		</div>

		<b-popover :show="showProfileMenu" target="show-profile-button" id="popover-profile-menu" :title="null" placement="bottom">
			<b-row>
				<b-col class="col" sm="auto">
					<div><b-link to="/my-settings">Account</b-link></div>
					<div><b-link to="/my-notifications">Notification Settings</b-link></div>
					<div><b-link to="/admin/user-list">Users</b-link></div>
					<div><b-link to="/admin/organization-list">Organization</b-link></div>
					<div><button id="logout-btn" type="button" class="btn btn-secondary btn-sm" @click="logout">
						Logout
					</button>
				</div>
			</b-col>
		</b-row>
	</b-popover>

	<b-popover id="popover-map-legend" target="google-map-legend-btn" triggers="click" placement="bottom">
		<template v-slot:title>Legend</template>
		<ul class="google-map-legend-list">
			<li><div class="legend-line" style="border-color: #33BB33;"></div><span>Pending</span></li>
			<li><div class="legend-line" style="border-color: #FFFF00;"></div><span>Upcoming</span></li>
			<li><div class="legend-line" style="border-color: #FF7314;"></div><span>Current</span></li>
			<li><div class="legend-line" style="border-color: #CC0505;"></div><span>Expired</span></li>
			<li><div class="legend-line" style="border-color: #293C7C;"></div><span>This Request</span></li>
			<li><div class="legend-block-marker has-conflicts"><span class='icon-alert-circle'></span></div><span>Conflicting Requests</span></li>
			<li><div class="legend-block-marker"><span>3</span></div><span>Overlapping Requests</span></li>
		</ul>
	</b-popover>

	<b-popover :show="showNotifications && showMessageTab == true" target="list-filter-messages-button" id="popover-messages" placement="bottom">
		<template #title>
			Messages <b-badge v-show="messageNotificationsCount > 0">{{messageNotificationsCount}}</b-badge>
			<router-link v-if="false" class="btn text-primary btn-sm btn-text float-right btn-notification-settings" to="/my-notifications"><span>Settings</span></router-link>
			<b-link class="btn text-primary btn-sm btn-text float-right btn-notification-settings" @click="clearAllClick('messages')"><span>Mark All Read</span></b-link>

		</template>
		<b-row v-for="(entry, i) in messageNotifications" :key="i" class="	">
			<b-col cols="1">
				<svg width="10" height="10">
					<circle cx="5" cy="5" r="5" :fill="getNotificationBubbleColor(entry)"/>
				</svg>
			</b-col>
			<b-col @click="goToNotificationDest(entry)">
				<p v-if="entry.messageTitle != ''">{{entry.messageTitle}}</p>
				<h6 v-html="entry.message"></h6>
				<p>{{moment(entry.notificationDate).fromNow()}}</p>
			</b-col>
		</b-row>
		<b-row v-if="messageNotifications.length < 1">
			<b-col>
				<p>No Notifications</p>
			</b-col>
		</b-row>
	</b-popover>

	<b-popover :show="showNotifications && showMessageTab == false" target="list-filter-updates-button" id="popover-updates" placement="bottom">
		<template #title>
			Updates <b-badge v-show="updateNotificationsCount > 0">{{updateNotificationsCount}}</b-badge>

			<router-link v-if="false" class="btn text-primary btn-sm btn-text float-right btn-notification-settings" to="/my-notifications"><span>Settings</span></router-link>
			<b-link class="btn text-primary btn-sm btn-text float-right btn-notification-settings" @click="clearAllClick('updates')"><span>Mark All Read</span></b-link>
		</template>
		<b-row v-for="(entry, i) in updateNotifications" :key="i" class="notification-entry">
			<b-col cols="1">
				<svg width="10" height="10">
					<circle cx="5" cy="5" r="5" :fill="getNotificationBubbleColor(entry)"/>
				</svg>
			</b-col>
			<b-col @click="goToNotificationDest(entry)">
				<p v-if="entry.messageTitle">{{entry.messageTitle}}</p>
				<h6 v-html="entry.message"></h6>
				<p>{{moment(entry.notificationDate).fromNow()}}</p>
			</b-col>
		</b-row>
		<b-row v-if="updateNotifications.length < 1">
			<b-col>
				<p>No Notifications</p>
			</b-col>
		</b-row>
	</b-popover>




	<b-modal centered v-model="showError500Modal" type="error" @ok="onNetworkError500ModalOk" ok-title="Ok" ok-only>
		<template v-slot:modal-title>Lane Closures Error</template>
		<p>System error 500.</p>
		<p v-html="errorMessage()"></p>
		<template slot="footer">
			<b-button colour="light" :value="$t('labels.ok')" @click="onNetworkErrorModalOk" />
		</template>
	</b-modal>

	<b-modal centered v-model="showNetworkErrorModal" type="error" @ok="onNetworkErrorModalOk" ok-title="Ok" ok-only>
		<template v-slot:modal-title>Network Error</template>
		<p>Could not connect to the lane closures system.  Please check your internet connection and try submitting again.</p>
		<template slot="footer">
			<b-button colour="light" :value="$t('labels.ok')" @click="onNetworkErrorModalOk" />
		</template>
	</b-modal>


	<b-modal centered v-model="showNoAccessModal" type="error" @ok="onNoAccessModalOk" ok-title="Ok" ok-only>
		<template v-slot:modal-title>No Access</template>
		<p>Sorry, you do not have access perform this function.</p>
		<template slot="footer">
			<b-button colour="light" :value="$t('labels.ok')" @click="onNetworkErrorModalOk" />
		</template>
	</b-modal>


	<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="onRequiredModalOk">
		<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
		<strong v-if="modalRequiredFieldsMessage" v-html="modalRequiredFieldsMessage"></strong>
		<ul>
			<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
		</ul>
		<template slot="footer">
			<b-button colour="light" :value="$t('labels.ok')" @click="onRequiredModalOk" />
		</template>
	</b-modal>

	<b-modal centered v-model="showDiscardModal" type="info" @ok="onDiscardChangeRequest" ok-title="Yes, Discard Requested Changes" cancel-title="No">
		<template v-slot:modal-title>Confirm Discard of Requested Changes</template>
		<p>Are you sure you want discard the changes you have requested for this lane closure?</p>
	</b-modal>

	<b-modal centered v-model="showCompletedModal" type="info" @ok="onCompleteRequest" ok-title="Yes, Complete Request" cancel-title="No">
		<template v-slot:modal-title>Confirm Completion</template>
		<p>Ensure that all lanes are open and restrctions are removed before completing this lane closure request.</p>
		<p>Do you want to set this request to completed?</p>
		<p>Completing will automatically report any closures as re-opened and restrictions as removed.</p>
	</b-modal>
	<b-modal centered v-model="showCancelModal" type="info" @ok="onCancelRequest" ok-title="Yes, Cancel Request" cancel-title="No">
		<template v-slot:modal-title>Confirm Cancellation of Request</template>
		<p>Are you sure you want to cancel this request?</p>
	</b-modal>

	<b-modal centered v-model="showLoginExpire" type="info" @hidden="redirectToLogin" ok-only >
		<template v-slot:modal-title>Login Expired</template>
		<b-row>
			<b-col>
				<p>Your login session has expired. Please login again.</p>
			</b-col>
		</b-row>
	</b-modal>

	<b-modal centered v-model="showTestingModal" type="info" @ok="onConfirmTesting" ok-title="Yes, Switch" cancel-title="No">
		<template v-slot:modal-title>Testing Mode Confirmation</template>
		<p>You have tapped the City of Winnipeg menu icon six times to try a different version of the app.</p>
		<p>Are you sure you want to load the following version of the app:</p>
		<strong v-html="showProcessSwapName()"></strong>
		<p>To return to the live version of the lane closures system, simply close and re-launch the application.</p>
	</b-modal>


</ion-app>
</template>
<script>
import BootstrapField from './utility/BootstrapField';
import Numeral from 'numeral';
import { Slide } from 'vue-burger-menu';
import { gmapApi } from 'gmap-vue'
import SlideUpMenu from './components/SlideUpMenu.vue'
import Datepicker from 'vuejs-datepicker';
import ErrorHandler from './utility/ErrorHandler';

import PageNavMobile from './components/PageNavMobile.vue'

import LaneClosureRequest from './models/LaneClosureRequest.js'
import Format from './utility/Format'
import Vue from 'vue'
import { mapActions } from 'vuex';

import PushToast from './components/PushToast.vue'
import EdgeCheck from 'vue-edge-check'
Vue.use(EdgeCheck)

// Disabling push notifications fo rnow.
// import { FCM } from '@capacitor-community/fcm';
// import { Plugins, PushNotification, PushNotificationToken, PushNotificationActionPerformed, NotificationChannel } from '@capacitor/core';

// const { PushNotifications, LocalNotifications } = Plugins;
// const fcm = new FCM();

// import {
//   PushNotifications,
//   PushNotificationSchema,
// } from '@capacitor/push-notifications';
// import { FCM } from '@capacitor-community/fcm';

import { FCM } from '@capacitor-community/fcm';
import { PushNotifications } from '@capacitor/push-notifications';

export default {
	name: 'App',
	components: {
		Slide,
		SlideUpMenu,
		'date-picker': Datepicker,
		PageNavMobile,
	},
	data() {
		return {
			loadingNotifications:false,
			launchedWithNotification: null,
			pushNotifications: [],
			topicName: 'winnipeg-lane-closures',
			remoteToken: "",
			searchTimeout:null,
			mapSearchStreet:null,
			mapStreetOptions:[{
									id: null,
									label: "Any Street",
							}],
			isMapStreetsLoading:false,
			markerMapSearch:null,
			LaneClosureRequest,
			locale: localStorage.locale || 'en-CA',
			loaded: false,
			// mapAutocompleteRef: null,
			filterDate: {
			    startDate: null,
			    endDate: null,
			},
			keyboardDidShow:false,
			keyboardWillShow:false,
			keyboardDidHide:false,
			keyboardWillHide:false,
			showRequiredFieldModal:false,
			showNoAccessModal:false,
			loadMapTimeout: null,
			mapZoom:18,
			mapBoundsNE:null,
			mapBoundsSW: null,
			showCompletedModal:false,
			showDiscardModal: false,
			showCancelModal:false,
			showNetworkErrorModal:false,
			showError500Modal:false,
			overlapLcr:[],
			activeLcrIndex:0,
			error:null,
			httpResponseStatus:null,
			hasMapSearchTerms:false,
			mapFromDate: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date
			}),
			mapToDate: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date
			}),
			lcrFromDate: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date
			}),
			mapInfo:null,
			lcrToDate: new BootstrapField({
				value: null,
				type: BootstrapField.Types.date
			}),
			mapDatePickerBehaviour: {
				range: true,
				right: true,
				time: {
					nearestIfDisabled: false
				},
			},
			isLoadingMap:false,
			filterMapDateBy:'lcr',
			navOpen: false,
			isAdmin: false,
			popupE:null,
			showMenu: false,
			showMap: false,
			showSideMap: false,
			showBlockPicker: false,
			modalRequiredFieldList:[],
			modalRequiredFieldsMessage:null,
			showProfileMenu: false,
			showMessageTab:true,
			showNearby:true,
			modalTitle: "Under Development",
			modalBody: null,
			showDevelopmentModal: false,
			lcrId: null,
			marker: null,
			map: null,
			mapAutocomplete: null,
			infoWindowHtml: null,
			window: {
				width: 0,
				height: 0,
			},
			showMapFullScreen: 0,
			disableSideMenuOutsideClickWindow: true,
			disableSideMenuOutsideClickMenu: true,
			slideUpMenu: null,
			recordStatusId: null,

			messageNotifications: [],
			messageNotificationsCount: 0,
			updateNotifications: [],
			updateNotificationsCount: 0,
			showNotifications: false,
			showLoginExpire: false,
			showTestingModal:false,
			showTestingCounter:0,
			touchstartX: null,
			touchstartY:null,
			touchendX:null,
			touchendY:null,
			touchstartTarget:null,
			touchendTarget:null,
		};
	},
	watch: {
		'$route.params.id'(newId, oldId) {
			let parsedNewValue = parseInt(newId);
			if (!isNaN(parsedNewValue)) {
				if (parsedNewValue !== oldId) {
					// Close Street view only if url id changes
					// Stay on opened street view across detail tabs
					this.closeStreetView();
				}
			} else {
				// id = undefined when returns back to listing
				// close the opened map
				this.toggleMap(0);
			}
		},
		'filterMapDateBy': function() {
			this.onSetMapDateFields(this.filterMapDateBy);
		},
		'isLoggedIn': function() {
			if (this.isLoggedIn) {
				this.getUnreadNotifications();
			}
		}
	},
	 async mounted() {
		// let that = this;
		await this.$gmapApiPromiseLazy();

		document.body.addEventListener('touchstart', this.onTouchStart, false);
		document.body.addEventListener('touchend', this.onTouchEnd,false);

		if (document.getElementById("vue-map-wrapper")) {
		document.getElementById("vue-map-wrapper").addEventListener('touchstart', this.onMapTouchStart, false);
		document.getElementById("vue-map-wrapper").addEventListener('touchend', this.onMapTouchEnd,false);
		}

		// this.trackMe();
		// this.aboutMe();

		var token = localStorage.getItem('token');
		if (token) {
			this.$store.dispatch('aboutMe').catch(function(error) {});
		} else {
			this.aboutMe();
		}
		/*
		var token = localStorage.getItem('token');
		if (token) {
			this.$store.dispatch('aboutMe').catch(function(error) {});
			// force a reload every day.

			let currentDate = Vue.prototype.moment();
			let lastCheck = currentDate.format("yyyy-MM-DD");
			var lastReloaded = localStorage.getItem('cacheBuster');
			if (lastReloaded != lastCheck) {
				localStorage.setItem("cacheBuster", lastCheck);
				if (window.location.href.indexOf("?") == -1) {
					window.location.href= window.location.href + "?cacheBuster="+Math.random();
				} else {
					window.location.href= window.location.href + "&cacheBuster="+Math.random();
				}
			}
		}
		*/


		if (this.$refs.mapRef) {
			this.$refs.mapRef.$mapPromise.then((map) => {

				// this is hacky way of giving deeper zoom
				// https://stackoverflow.com/questions/30136525/allow-further-zoom-on-google-maps-v3-satellite-view#
				// going any higher than 20 will cause "no images available error" on flat tiled.
				// can go to 21 on the tilted satellite view.
				/*
				var zoomRangeModifier = map.__proto__.__proto__.__proto__;
				var originalSetFunc = zoomRangeModifier.set;
				var hijackedSetFunc = function(name, value) {
				    if (name === 'maxZoom') { // Old API: name === 'zoomRange'
				        value = 20;           // Old API: value.max = 23;
				    }
				    originalSetFunc.call(this, name, value);
				};
				zoomRangeModifier.set = hijackedSetFunc;
				*/
				this.$map = map;
				// this.$mapPlacesService = this.googleMap.maps.places.PlacesService(this.$map);
				this.$mapRef = this.$refs.mapRef;
				this.map = map;


				this.addYourLocationButton();
				this.addMapControlButtons();

				// this.mapPlacesService = this.googleMap.maps.places.PlacesService(this.map);
				this.$store.commit('map/setMap', this.map);
				// this.$store.commit('map/setPlacesService', this.googleMap.maps.places.PlacesService(this.map));
				this.$store.commit('map/setRef', this.$refs.mapRef);

			})
		}
		window.addEventListener('resize', this.handleResize);
		this.handleResize();

		Vue.prototype.$bus.$off('menu:toggle', this.toggleMenu);
		Vue.prototype.$bus.$off('map:streetSearch', this.onMapStreetSearchAndPreselect);
		Vue.prototype.$bus.$off('map:toggle', this.toggleMap);
		Vue.prototype.$bus.$off('map:toggleAndZoom', this.toggleMapAndZoom);
		Vue.prototype.$bus.$off("notification:togglemessages", this.toggleMessages);
		Vue.prototype.$bus.$off("notification:toggleupdates", this.toggleUpdates);
		Vue.prototype.$bus.$off('map:toggleSideMap', this.toggleSideMap);
		Vue.prototype.$bus.$off('map:showBlockPicker', this.toggleBlockPicker);
		Vue.prototype.$bus.$off('map:hideWhenMobile', this.hideMapWhenMobile);
		Vue.prototype.$bus.$off('map:showMapWhenDesktop', this.showMapWhenDesktop);
		Vue.prototype.$bus.$off('map:setMapDateFields', this.onSetMapDateFields);
		Vue.prototype.$bus.$off('map:set-lcr-id', this.setLcrId);
		Vue.prototype.$bus.$off('map:set-lcr-date-range', this.setLcrDateRange);
		Vue.prototype.$bus.$off('map:loading', this.loadingMap);
		Vue.prototype.$bus.$off('map:loadNearby', this.loadNearby);

		Vue.prototype.$bus.$off('map:toggleFullScreen', this.toggleMapFullScreen);
		Vue.prototype.$bus.$off('map:exitIfFullScreen', this.exitIfFullScreen);
		Vue.prototype.$bus.$off('map:clear', this.clearMap);
		Vue.prototype.$bus.$off('show-modal-under-development', this.showUnderDevelopmentModal);
		Vue.prototype.$bus.$off('map:block-popup', this.nearbyBlockPopup);
		Vue.prototype.$bus.$off('map:overlap-block-popup', this.overlapBlockPopup);
		Vue.prototype.$bus.$off('map:nearby-block-popup', this.nearbyBlockPopup);
		Vue.prototype.$bus.$off('map:block-picker-popup', this.blockPickerPopup);
		Vue.prototype.$bus.$off('map:reset-side-bar', this.resetSideBar);
		Vue.prototype.$bus.$off('map:close-street-view', this.closeStreetView);

		Vue.prototype.$bus.$off('app:showLoginExpireDialog', this.openLoginExpire);
		Vue.prototype.$bus.$off("filter:setShowMine", this.setShowMine);

		Vue.prototype.$bus.$off('app:registerDevice', this.registerDevice);
		Vue.prototype.$bus.$on('app:registerDevice', this.registerDevice);
		Vue.prototype.$bus.$on('error:network', this.showNetworkError);
		Vue.prototype.$bus.$on('http:responseStatus', this.setHttpResponseStatus);


		Vue.prototype.$bus.$off("push:clicked", this.pushNotificationClicked);
		Vue.prototype.$bus.$on("push:clicked", this.pushNotificationClicked);
		Vue.prototype.$bus.$off("push:process-launch", this.pushNotificationLaunched);
		Vue.prototype.$bus.$on("push:process-launch", this.pushNotificationLaunched);

		Vue.prototype.$bus.$on('menu:toggle', this.toggleMenu);
		Vue.prototype.$bus.$on('map:streetSearch', this.onMapStreetSearchAndPreselect);
		Vue.prototype.$bus.$on('map:toggle', this.toggleMap);
		Vue.prototype.$bus.$on('map:toggleAndZoom', this.toggleMapAndZoom);
		Vue.prototype.$bus.$on("notification:togglemessages", this.toggleMessages);
		Vue.prototype.$bus.$on("notification:toggleupdates", this.toggleUpdates);
		Vue.prototype.$bus.$on('map:toggleSideMap', this.toggleSideMap);
		Vue.prototype.$bus.$on('map:showBlockPicker', this.toggleBlockPicker);
		Vue.prototype.$bus.$on('map:hideWhenMobile', this.hideMapWhenMobile);
		Vue.prototype.$bus.$on('map:showMapWhenDesktop', this.showMapWhenDesktop);
		Vue.prototype.$bus.$on('map:setMapDateFields', this.onSetMapDateFields);
		Vue.prototype.$bus.$on('map:set-lcr-id', this.setLcrId);
		Vue.prototype.$bus.$on('map:set-lcr-date-range', this.setLcrDateRange);
		Vue.prototype.$bus.$on('map:loading', this.loadingMap);
		Vue.prototype.$bus.$on('map:loadNearby', this.loadNearby);
		Vue.prototype.$bus.$on('map:loadNearbyBounded', this.loadNearbyBounded);

		Vue.prototype.$bus.$on("filter:setShowMine", this.setShowMine);

		Vue.prototype.$bus.$on('map:toggleFullScreen', this.toggleMapFullScreen);
		Vue.prototype.$bus.$on('map:exitIfFullScreen', this.exitIfFullScreen);
		Vue.prototype.$bus.$on('map:clear', this.clearMap);
		Vue.prototype.$bus.$on('show-modal-under-development', this.showUnderDevelopmentModal);
		Vue.prototype.$bus.$on('map:block-popup', this.nearbyBlockPopup);
		Vue.prototype.$bus.$on('map:overlap-block-popup', this.overlapBlockPopup);
		Vue.prototype.$bus.$on('map:nearby-block-popup', this.nearbyBlockPopup);
		Vue.prototype.$bus.$on('map:block-picker-popup', this.blockPickerPopup);
		Vue.prototype.$bus.$on('map:block-closure-popup', this.blockClosurePopup);
		Vue.prototype.$bus.$on('map:reset-side-bar', this.resetSideBar);
		Vue.prototype.$bus.$on('map:close-street-view', this.closeStreetView);

		Vue.prototype.$bus.$on('app:showLoginExpireDialog', this.openLoginExpire);

		Vue.prototype.$bus.$on('slideUpMenu:hideAll', this.hideAllSlideUpMenu);


		this.getTotals();
		this.getUnreadNotifications();
		this.initSignalR();
		this.initMenuClickEvent();

		    // console.log("platformId:"+platformId);
	    const isPushNotificationsAvailable = Capacitor.isPluginAvailable('PushNotifications');

	    if (isPushNotificationsAvailable) {
	    	// external required step
	    	// register for push
	    	// await PushNotifications.requestPermissions();
	    	// await PushNotifications.register();

	    	// Get FCM token instead the APN one returned by Capacitor
	    	// FCM.getToken()
	    	//   .then((r) => {
	    	//   	alert(`Token ${r.token}`)
				  // localStorage.setItem("deviceId", JSON.stringify(r.token));
	    	//   })
	    	//   .catch((err) => console.log(err));



		PushNotifications.addListener('registration', (data) => {
				let that = this;
		  // alert(JSON.stringify(data));
				  // console.log("registration");
				  // console.log(data);
				  // localStorage.setItem("deviceId", JSON.stringify(data));
				  this.$store.commit("setDeviceId", data.value);

			      	// Get FCM token instead of the APN one returned by Capacitor
			      	FCM.getToken()
			      	  .then((r) => {
			  				that.$store.commit("setDeviceId", r.token);
			  				this.$store.dispatch('registerDeviceId').catch(function(error) {});
			      	  })
			      	  .catch((err) => console.log(err));
		});
		PushNotifications.addListener(
		  'pushNotificationReceived',
		  (notification) => {
				let that = this;
				console.log("pushNotificationReceived");

			    // console.log("lcrId:"+notification.data.lcrId);
			    // console.log('notification ' + JSON.stringify(notification));
		      this.pushNotifications.push(notification);
			      const content = {
			          component: PushToast,
			          props: {
			              data: notification
			          },
			          listeners: {
			          }
			      };
			      this.$toast(content, {
			      timeout:false,
			      hideProgressBar:true,
			      closeOnClick: false,
			      });
		  }
		);

			this.launchedWithNotification = null;

			PushNotifications.addListener(
			  'pushNotificationActionPerformed',
			  (action) => {
				let that = this;
				console.log("pushNotificationActionPerformed");
				console.log(action);
				that.launchedWithNotification = action.notification;
				if (that.$router.currentRoute.name != null) {
					Vue.prototype.$bus.$emit("push:clicked", that.launchedWithNotification);
				}
			  }
			);

			PushNotifications.requestPermissions().then((response) => {
		  	PushNotifications.register().then(() => {
				console.log("registered for push");
		  	})
		});
	    }



	},

	computed: {
		getMarkAsCompletedText() {
			let txt = "Mark as Completed";
			if (this.isLoggedIn) {
				if(this.$store.getters['laneClosureRequest/data'] != null) {
					if (this.$store.getters['laneClosureRequest/data'].approvalStatusId.value == 2 && this.$store.getters['laneClosureRequest/data'].recordStatusId.value != 7) {
						txt = "Mark as Completed";
					}
					if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value != null) {
						if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value == 2) {
							txt = "Already Completed";
						}
						if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value == 3) {
							txt = "Denied - Cannot mark as Completed";
						}
						if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value == 4) {
							txt = "Cancelled - Cannot mark as Completed";
						}
					}

					if (txt == "") {
						txt = "Waiting for Approval";
					}
				} else {
					txt = "Mark as Completed";
				}
			} else {
				txt = "Mark as Completed";
			}
			return txt;
		},
		getCannotMarkAsCompletedText() {
			let txt = "";
			if (this.isLoggedIn) {
				if(this.$store.getters['laneClosureRequest/data'] != null) {
					if (this.$store.getters['laneClosureRequest/data'].approvalStatusId.value == 2 && this.$store.getters['laneClosureRequest/data'].recordStatusId.value != 7) {
						txt = "Mark as Completed";
					}
					if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value != null) {
						if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value == 2) {
							txt = "Already Completed";
						}
						if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value == 3) {
							txt = "Denied - Cannot mark as Completed";
						}
						if (this.$store.getters['laneClosureRequest/data'].completeTypeId.value == 4) {
							txt = "Cancelled - Cannot mark as Completed";
						}
					}
					if (txt == "") {
						txt = "Waiting for Approval";
					}
				} else {
					txt = "Mark as Completed";
				}
			} else {
				txt = "Mark as Completed";
			}
			if (txt == "") {
				"Cannot Complete";
			}
			return txt;
		},
		canMarkAsCompleted() {
			let canMark = false;
			if (this.isLoggedIn) {
				if(this.$store.getters['laneClosureRequest/data'] != null) {
					if (this.$store.getters['laneClosureRequest/data'].approvalStatusId.value == 2 && this.$store.getters['laneClosureRequest/data'].recordStatusId.value != 7 && this.$store.getters['laneClosureRequest/data'].completeTypeId.value == null) {
						canMark = true;
					}
				}
			}
			return canMark;
		},
		violationCount() {
			if (this.isLoggedIn) {
			if(this.$store.getters['reportContraventionList/getTotals']) {
					if (this.$store.getters['reportContraventionList/getTotals'].contraventions) {
				return this.$store.getters['reportContraventionList/getTotals'].contraventions.with;
					}
			} else {
				return 0;
			}
			}
			return 0;
		},
		nearbyRecordCount() {
			if (!this.isLoggedIn) {
				return 0;
			}
			return this.$store.getters["map/nearbyPolylines"].length;
		},
		markerCount() {
			if (!this.isLoggedIn) {
				return 0;
			}
			return this.$store.getters["map/markers"].length;
		},
		dateRangePickerRanges() {
			return Format.getLocalDatePickerRanges();
		},
		showMenuPrimary:function() {
			switch(this.$route.name) {
				case 'EditLaneClosureRequest':
					return false;
				case 'EditRequestedChanges':
				return false;
				case 'ViewRequestedChanges':
				return false;
				case 'ViewRequestedChangesCacheBuster':
				return false;
				case 'AddLaneClosureRequest':
					return false;
				case 'DuplicateLaneClosureRequest':
				return false;
				case 'AddLaneClosureRequestWithContravention':
					return false;
				case 'ReportClosure':
					return false;
				case 'ReportRestriction':
					return false;
				case 'ReportContravention':
					return false;
			}
			// If we are looking at Requested Changes
			// let menuRequestedChanges = !this.showMenuRequestedChanges;
			// if (menuRequestedChanges) {
			// 	return menuRequestedChanges;
			// }

			return !this.showMenuRequest;
		},

		showMenuRequest:function() {
			switch(this.$route.name) {
			case 'ViewLaneClosureRequest':
				return true;
				case 'ViewLaneClosureRequestCacheBuster':
				return true;
				case 'ViewRequestedChanges':
				return false;
			case 'ViewLaneClosureRequestScrollTo':
				return true;
			case 'EditLaneClosureRequest':
				return false;
				case 'EditRequestedChanges':
				return false;
			case 'ReportClosure':
				return false;
			case 'ReportContravention':
				return false;
			case 'EditContravention':
				return true;
			case 'ViewContravention':
				return true;
			case 'LaneClosureRequestActivity':
				return true;
			case 'LaneClosureRequestAttachments':
				return true;
			case 'LaneClosureRequestContraventions':
				return true;
				case 'ReportRestriction':
				return false;
			case 'LaneClosureRequestActivityCacheBuster':
				return true;
			case 'LaneClosureRequestAttachmentsCacheBuster':
				return true;
			case 'LaneClosureRequestContraventionsCacheBuster':
				return true;
			}
				return false;
		},

		showMenuRequestedChanges:function() {
			switch(this.$route.name) {
				case 'ViewRequestedChanges':
					return true;
				case 'ViewRequestedChangesCacheBuster':
					return true;
				case 'ViewRequestedChangesScrollTo':
					return true;
			}
			return false;
		},

		profileName:function() {
			return "Account / Settings";
			/*
			// TODO: when the user first name or last name is changed, we need to notify when that happens.
			// So for now, we'll just show generic text.
			let userInfo = this.$store.getters.userInfo();
			if (userInfo) {
			return userInfo.firstName + " " + userInfo.lastName ;
			}
			return "";
			*/
		},
		getNotificationTarget: function() {
			if (this.showMessageTab == true) {
				return "list-filter-messages-button";
			} else {
				return "list-filter-updates-button";
			}
		},
		canReportContravention: function() {
			return this.$store.getters.userCanReportContravention();
		},
		filterMapDateByOptions: function() {
			let options = [];
			options.push({text:"Selected Request", value:"lcr"});
			options.push({text:"Today", value:"today"});
			options.push({text:"Today (+- 3 business days)", value:"today-3days"});
			options.push({text:"Yesterday", value:"yesterday"});
			options.push({text:"Any time", value:"all"});
			return options;
		},

		googleMap: gmapApi,
		isLoggedIn: function() {
			return this.$store.getters.isLoggedIn
		},

		shouldShowMenu: function() {
			if (this.showMenu && this.$store.getters.isLoggedIn) {
				return true;
			}
			return false;
		},
	},
	methods: {
		...mapActions([
			'aboutMe'
		]),

		hasChangesRequested() {
			this.laneClosureRequest = this.$store.getters['laneClosureRequest/data'];
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.lcrChangeRequestId) {
					return true;
				}
			}
			return false;
		},


		onKeyboardWillShow() {
			this.keyboardWillShow = true;
			this.keyboardDidHide = false;
			this.keyboardWillHide = false;
			this.keyboardDidShow = false;
		},
		onKeyboardWillHide() {
			this.keyboardWillHide = true;
			this.keyboardDidHide = false;
			this.keyboardDidShow = false;
			this.keyboardWillShow = false;
		},

		onKeyboardDidShow() {
			this.keyboardDidShow = true;
			this.keyboardDidHide = false;
			this.keyboardWillHide = false;
			this.keyboardWillShow = false;
		},
		onKeyboardDidHide() {
			this.keyboardDidHide = false;
			this.keyboardWillHide = false;
			this.keyboardDidShow = false;
			this.keyboardWillShow = false;
		},

		onTouchStart(event) {
			event.stopPropagation();
			this.touchstartTarget = event.target;
		    this.touchstartX = event.changedTouches[0].screenX;
		    this.touchstartY = event.changedTouches[0].screenY;
			if (event.changedTouches[0].screenX < 0) {
				this.touchstartX = event.changedTouches[0].pageX;
			}
			if (event.changedTouches[0].screenY < 0) {
				this.touchstartY = event.changedTouches[0].pageY;
			}
		},
		onTouchEnd(event) {
			this.touchendTarget = event.target;
			event.stopPropagation();
		    this.touchendX = event.changedTouches[0].screenX;
		    this.touchendY = event.changedTouches[0].screenY;
			if (event.changedTouches[0].screenX < 0) {
				this.touchendX = event.changedTouches[0].pageX;
			}
			if (event.changedTouches[0].screenY < 0) {
				this.touchendY = event.changedTouches[0].pageY;
			}
		    this.handleGesture();
		},

		onMapTouchStart(event) {
			event.stopPropagation();
		    this.touchstartX = event.changedTouches[0].screenX;
		    this.touchstartY = event.changedTouches[0].screenY;
		},
		onMapTouchEnd(event) {
			event.stopPropagation();
		    this.touchendX = event.changedTouches[0].screenX;
		    this.touchendY = event.changedTouches[0].screenY;
		    if (event.changedTouches[0].screenX < 0) {
		    	this.touchendX = event.changedTouches[0].pageX;
		    }
		    if (event.changedTouches[0].screenY < 0) {
		    	this.touchendY = event.changedTouches[0].pageY;
		    }
		    this.handleMapGesture();
		},



		handleMapGesture() {
			// swiping map shouldn't matter...
			return;
		    // if (this.touchendX < this.touchstartX) {
		    //     if (this.$isEdgeRight) {
		    //     	// console.log('Swiped Left');
			   //      let hasOwnSwipeHandler = [
			   //      ];
			   //      if (hasOwnSwipeHandler.indexOf(this.$router.currentRoute.name) != -1) {
			   //      	Vue.prototype.$bus.$emit("swipe:left");
			   //      }
			   //  }
		    // }

		    // if (this.touchendX > this.touchstartX) {
		    // 	// Sometimes it can't detect isEdgeLeft so we have to use the x coordinate...
		    //     if (this.$isEdgeLeft ||
		    //    		(this.touchstartX > -710 && this.touchstartX < -662 && this.touchendX > -622)
		    //     ) {
			   //      this.onHideMap();
			   //  }
		    // }
		    // if (this.touchendY < this.touchstartY) {
		    //     console.log('Swiped Up');
		    // }

		    // if (this.touchendY > this.touchstartY) {
		    //     console.log('Swiped Down');
		    // }

		    // if (this.touchendY === this.touchstartY) {
		    //     console.log('Tap');
		    // }
		},

		handleGesture() {
			// ignore swipe gestures while the form wizard tabs.
			if (this.touchstartTarget.parentNode.parentNode.id) {
				if (this.touchstartTarget.parentNode.parentNode.id.indexOf("wizardTab") != -1) {
					return;
				}
			}
			if (this.touchstartTarget.parentNode.id) {
				if (this.touchstartTarget.parentNode.id.indexOf("wizardTab") != -1) {
					return;
				}
			}

		    if (this.touchendX < this.touchstartX) {
		        if (this.$isEdgeRight) {
		        	// console.log('Swiped Left');
			        let hasOwnSwipeHandler = [
			        ];
			        if (hasOwnSwipeHandler.indexOf(this.$router.currentRoute.name) != -1) {
			        	Vue.prototype.$bus.$emit("swipe:left");
			        	return;
			        }
			    }
		    }

		    if (this.touchendX > this.touchstartX) {
		    	// console.log(this.touchstartX);
		    	// console.log(this.touchendX);
		    	// console.log(this.$isEdgeLeft);

		    	// Sometimes it can't detect isEdgeLeft so we have to use the x coordinate...
		        if (this.$isEdgeLeft
		       		|| (this.touchstartX > -710 && this.touchstartX < -662 && this.touchendX > -622)
		       		|| (this.touchstartX >= 0 && this.touchstartX < 48 && this.touchendX >= 48)
		        ) {
			        // console.log('Swiped Right');
			        let hasOwnSwipeRightHandler = [
			        'ReportRestriction',
			        'ReportClosure',
			        'ViewLaneClosureRequest',
			        'LaneClosureList',
			        'Login',
			        'ReportRestrictionSearch',
					'ReportContraventionSearch',
					'ReportClosureSearch',
					'EditLaneClosureRequest',
					'AddLaneClosureRequest',
					'AddLaneClosureRequestWithContravention',
					'Login',
					'login',
					'home',
					'Home',
			        ];
			        if (hasOwnSwipeRightHandler.indexOf(this.$router.currentRoute.name) != -1) {
			        	Vue.prototype.$bus.$emit("swipe:right");
			        	return;
			        } else {
			        	// lets just navigate back
			        	this.$router.go(-1);
			        	return;
			        }
			    }
		    }
		    // if (this.touchendY < this.touchstartY) {
		    //     console.log('Swiped Up');
		    // }

		    if (this.touchendY > this.touchstartY) {
                if ((this.touchstartY > 0 && this.touchstartY < 80 && this.touchendY >= 80)) {
        	        Vue.prototype.$bus.$emit("swipe:down");
        	        /*
        	        // console.log('Swiped Right');
        	        let hasOwnSwipeDownHandler = [
        	        'ViewLaneClosureRequest'
        	        ];
        	        if (hasOwnSwipeRightHandler.indexOf(this.$router.currentRoute.name) != -1) {
        	        	Vue.prototype.$bus.$emit("swipe:down");
        	        	return;
        	        } else {
        	        	// lets just navigate back
        	        	this.$router.go(-1);
        	        	return;
        	        }
        	        */
        	        return;
        	    }
		    }

		    // if (this.touchendY === this.touchstartY) {
		    //     console.log('Tap');
		    // }
		},
		doNothing() {
			// yup, its nothing.
		},
		mainClasses() {
			let classes = "";
			if (this.$router.currentRoute.name != null) {
				if (!this.isLoggedIn) {
					classes += " not-logged-in";
				}
				if (!this.checkPath()) {
					classes += " no-menu";
				}
				if (!this.checkPath()) {
					classes += " no-menu";
				}
				classes += " page-"+this.$router.currentRoute.name;
				return classes;
			}
			return {'not-logged-in':!this.isLoggedIn, 'no-menu': !this.checkPath()};
		},
		goToAppUrl(data) {
			this.$router.push(data.url);
		},

		pushNotificationClicked(notification) {
			if (notification) {
				if (notification.data) {
					if (notification.data.lcrId) {
						if (notification.data.notificationTypeId == "new-message") {
							this.$router.push({name:"ViewLaneClosureRequest", params:{id: notification.data.lcrId}});
						} else {
							// just open the lane closure request by default.
							this.$router.push({name:"ViewLaneClosureRequest", params:{id: notification.data.lcrId}});
						}
					}
						}
					}
			this.launchedWithNotification = null;
		},

		pushNotificationLaunched() {
			if (this.launchedWithNotification != null) {
				Vue.prototype.$bus.$emit("push:clicked", this.launchedWithNotification);
			}
		},
		listingView() {
			return false;
		},

		sidePages() {
			let showClassRoutes = [
				'UserList',
				'AuditLogList',
				'OrganizationList',
				'AppUserRequestList',
				'OrganizationRequestList',
			];
			return showClassRoutes.indexOf(this.$router.currentRoute.name) != -1;
		},

		canCompleteRequest() {
		    this.$store.getters['laneClosureRequest/data'];
		    if (this.$store.getters.userInfo() == null) {
		        return false;
		    }
		    if (this.$store.getters['laneClosureRequest/data'] == null) {
		        return false;
		    }
		    let canReport = false;
		    if (this.$store.getters['laneClosureRequest/data']) {
		        if (this.$store.getters['laneClosureRequest/data'].approvalStatusId.value == 2 && this.$store.getters['laneClosureRequest/data'].recordStatusId.value != 7) {
		            let thisUserId = this.$store.getters.userId();
		            let thisOrgId = this.$store.getters.userInfo().organizationId;
		            let canOrg = this.$store.getters.userHasPermission('lcr_update_org');
		            let canMine = this.$store.getters.userHasPermission('lcr_update_mine');
		            let canAll = this.$store.getters.userHasPermission('lcr_update_all');

		            if (!canMine && !canAll && !canOrg) {
		                return false;
		            }

		            if (canAll) {
		                canReport = true;
		            }

		            if (!canReport) {
		                if (this.$store.getters['laneClosureRequest/data'].closureReporterId == thisUserId && (canOrg || canMine)) {
		                    canReport = true;
		                }
		                if (this.$store.getters['laneClosureRequest/data'].requesterId == thisUserId && (canOrg || canMine)) {
		                    canReport = true;
		                }
		            }

		            let x = 0;
		            let orgs = [];


		            if (!canReport) {
		                if (canOrg) {
		                    orgs = this.getOrganizationIdTreeList(this.$store.getters['laneClosureRequest/data'].requester);
		                    if (orgs.includes(""+thisOrgId)) {
		                        canReport = true;
		                    }
		                }
		            }
		            if (!canReport) {
		                if (this.$store.getters['laneClosureRequest/data'].altRequester) {
		                    for (x = 0; x < this.$store.getters['laneClosureRequest/data'].altRequester.length; x++) {
		                        if (thisUserId + "" == this.$store.getters['laneClosureRequest/data'].altRequester[x].userId + "") {
		                            canReport = true; // they can always report if they are an alternate requester...
		                        }
		                        if (canReport == false) {
		                            if (canOrg) {
		                                orgs = this.getOrganizationIdTreeList(this.$store.getters['laneClosureRequest/data'].altRequester[x]);
		                                if (orgs.includes(""+thisOrgId)) {
		                                    canReport = true;
		                                }
		                            }
		                        }
		                    }
		                }
		            }

		            if (!canReport) {
		                if (this.$store.getters['laneClosureRequest/data'].altClosureReporter) {
		                    for (x = 0; x < this.$store.getters['laneClosureRequest/data'].altClosureReporter.length; x++) {
		                        if (thisUserId + "" == this.$store.getters['laneClosureRequest/data'].altClosureReporter[x].userId + "") {
		                            canReport = true;
		                        }
		                        if (canReport == false) {
		                            if (canOrg) {
		                                orgs = this.getOrganizationIdTreeList(this.$store.getters['laneClosureRequest/data'].altClosureReporter[x]);
		                                if (orgs.includes(""+thisOrgId)) {
		                                    canReport = true;
		                                }
		                            }
		                        }
		                    }

		                }
		            }

		        }
		    }
		    return canReport;
		},
		shouldShowPageNav() {
			if (this.isLoggedIn) {
				if (this.$store.state.isMobile) {
					switch(this.$router.currentRoute.name) {
						case "UserList":
						case "OrganizationList":
						case "MyNotifications":
						case "MySettings":
						case "OrganizationRequestList":
						case "EditGlobalSettings":
						case "AuditLogList":
						case "AppUserRequestList":
						case "EditUser":
						case "EditOrganization":
						case "AddUser":
						case "NoAccess":
						case "AddOrganization":
						case "AddPrimaryOrganization":
						case "EditOrganizationRequest":
						case "EditAppUserRequest":
						case "AddNotificationSchedule":
						case "AddLaneClosureRequest":
				case "DuplicateLaneClosureRequest":
						case "EditNotificationSchedule":
						case "EditBanner":
						case "ReportClosure":
						case "ReportRestriction":
						case "ReportContravention":
						case "AddLaneClosureRequestWithContravention":
							return true;
						default:
							return false;
					}
				}
			}
			return false;
		},

		goBackUrl() {
			if (this.isLoggedIn) {
				if (this.$store.state) {
					return this.$store.state.goBackUrl;
				}
			}
			return null;
		},

		shouldShowPageNavFilter() {
			if (this.isLoggedIn) {
				if (this.$store.state.isMobile) {
					switch(this.$router.currentRoute.name) {
						case "UserList":
							return true;
						default:
							return false;
					}
				}
			}
			return false;
		},

		shouldShowPageNavBack() {
			if (this.isLoggedIn) {
				if (this.$store.state.isMobile) {
					switch(this.$router.currentRoute.name) {
						case "UserList":
							return true;
						default:
							return false;
					}
				}
			}
			return false;
		},


		checkPath() {
			let excludedPaths = ['/register', '/register-organization', '/confirm-user-registration'];
			let excludedRouteNames = ['ConfirmAppUserRegistration'];
			if (this.$router.currentRoute.name == null) {
				return false;
			}

			if(excludedPaths.indexOf(this.$router.currentRoute.path) !== -1 || excludedRouteNames.indexOf(this.$router.currentRoute.name.trim()) !== -1) {
				return false;
			}
			return true;
		},
			getMapBoundsBusStopLink() {
				let comma = "";
				let link = this.$store.state.busStopMapUrl + "&ll=";
				if (this.map) {
					link += comma + this.map.getCenter().lat() + "%2c" + this.map.getCenter().lng();
					link += "&z=" + this.map.getZoom();
					return link;
				}
				return null;
			},


		setShowMine(value) {
			// apply the Show Mine filter if it isn't already set.
			let arg = "globalFilter";
			let argQuery = JSON.parse(localStorage.getItem(arg))
			if (argQuery != null) {
				argQuery.showMine = value;
				localStorage.setItem(arg, JSON.stringify(argQuery))
			} else {
				argQuery = {
					showMine:value
				}
				localStorage.setItem(arg, JSON.stringify(argQuery))
			}
		},

		setHttpResponseStatus(status) {
			this.httpResponseStatus = status;
		},

		showNetworkError(data) {
			if (this.showNetworkErrorModal == true || this.showRequiredFieldModal == true || this.showNoAccessModal == true) {
				// already showing error
				return;
			}
			if (data) {
				if (data.error) {
					this.error = data.error;
					if (data.error) {
						if (ErrorHandler.HasConnectionError(data.error)) {
							this.showNetworkErrorModal = true;
						} else {
						if (!ErrorHandler.HasLoginErrorCode(data.error)) {
								if (!ErrorHandler.HasAccessErrorCode(data.error)) {
							var whichError = null;
							if (data.errors) {
								if (data.error.response) {
									if (data.error.response.data) {
										if (data.error.response.data.fields) {
											for (let field in data.errors) {
												this.modalRequiredFieldList.push(data.errors[field]);
											}
											whichError = "required";
										}
									}
								}
							}
							if (whichError == null) {
								if (data.error.response) {
									this.showNetworkErrorModal = true;
								} else {
									if(navigator.onLine){
										this.showNetworkErrorModal = true;
									} else {
										this.showNetworkErrorModal = true;
									}
								}
							}
							if (whichError == "required") {
								this.showRequiredFieldModal = true;
									} else {
										this.modalRequiredFieldsMessage = null;
										if (data.error.message) {
													this.modalRequiredFieldsMessage = data.error.message;
										}
							}
								} else {
									this.showNoAccessModal = true;
						}
					}
				}
			}
				}
			}
		},

		onNetworkErrorModalOk() {
			this.showNetworkErrorModal = false;
		},

		onNetworkError500ModalOk() {
			this.showError500Modal = false;
		},
		errorMessage() {
			if (this.error) {
				if (this.error.config) {
					return this.error.config.url;
				}
			}
			return "";
		},

		onRequiredModalOk() {
			this.showRequiredFieldModal = false;
		},

		onNoAccessModalOk() {
			this.showNoAccessModal = false;
		},

		showDiscardChangeRequestModal() {
			this.showDiscardModal = true;
		},

		showCompleteRequestModal() {
			this.showCompletedModal = true;
		},
		showCancelRequestModal() {
			this.showCancelModal = true;
		},
		onCancelRequest() {
			// TODO:  alert if there are still closed lanes or in-place restrictions.
			this.PostCancelLaneClosureRequest(this.laneClosureRequest);
		},
		PostCancelLaneClosureRequest(t) {
			this.cancelSaving = true;
			if (this.$route.params.id) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.$route.params.id}/cancelled?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					}).then(resp => {
						this.CancelLaneclosureRequestSuccess();
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.errorDetails = error.response.data;
							this.showErrors(error.response.data.fields);
							this.cancelSaving = false;
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
					});
				}
			}
		},

		CancelLaneclosureRequestSuccess() {
			this.cancelSaving = false;
			let lastPage = this.$routerStore.getters['getLastListPage'];
			if (lastPage == null) {
				this.$router.push({ name: "LaneClosureList" });
			}
			return this.$router.push(lastPage);
			// this.LoadLaneClosureRequest(this.$route.params.id);
		},


		onDiscardChangeRequest() {
			let go = false;

			if (this.$route.params.id) {
					if(this.$store.getters['laneClosureRequest/data'] != null) {
						if (this.$store.getters['laneClosureRequest/data'].changeRequest) {
							if (this.$store.getters['laneClosureRequest/data'].changeRequest.id > 0) {
								go = true;
							}
						}
					}
			}
				if (go) {
					this.completeSaving = true;
					this.isButtonDisabled = true;
					Vue.prototype.$http({
						method: 'put',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.$route.params.id}/discard-requested-changes/${this.$store.getters['laneClosureRequest/data'].changeRequest.id}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					}).then(resp => {
						this.DiscardChangesRequestSuccess();
						this.isButtonDisabled = false;
					}).catch(error => {
						console.log("error", error);
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							if (error.response) {
								if (error.response.data) {
									this.errorDetails = error.response.data;
									this.showErrors(error.response.data.fields);
								} else {
									this.errorDetails = null;
									this.showErrors(null);
								}
							}
							this.completeSaving = false;
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
						this.completeSaving = false;
					});
				}
		},
		DiscardChangesRequestSuccess() {
			this.completeSaving = false;
			this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.$route.params.id } });
		},



		onCompleteRequest() {
			// TODO:  alert if there are still closed lanes or in-place restrictions.
			this.PostCompleteLaneClosureRequest(this.laneClosureRequest);
		},

		PostCompleteLaneClosureRequest(t) {
			// Saves a new Lane closure request
			this.completeSaving = true;
			if (this.$route.params.id) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.$route.params.id}/completed?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					}).then(resp => {
						this.CompleteLaneclosureRequestSuccess();
					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.errorDetails = error.response.data;
							this.showErrors(error.response.data.fields);
							this.completeSaving = false;
						} else {
							// ErrorHandler.RedirectToLogin();
						}
					}).finally(() => {
						this.isButtonDisabled = false;
					});
				}
			}
		},

		CompleteLaneclosureRequestSuccess() {
			this.completeSaving = false;
			this.goBack();
		},


		formatDateRange(startDate,endDate) {
		    let sd = this.$moment(startDate);
		    let ed = this.$moment(endDate);
		    return sd.format('MM/DD/YYYY') + " - " + ed.format('MM/DD/YYYY');
		},
		goToReportRestriction() {
			if (this.$route.params) {
				if (this.$route.params.id) {
					// this.$router.push("/lane-closure-request/"+this.$route.params.id+"/view?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					this.$router.push({ name: "ReportRestriction", params: { id: this.$route.params.id } });
				}
			}
		},
		goBack() {
			let lastPage = this.$routerStore.getters['getLastListPage'];
			if (lastPage == null) {
				this.$router.push("/lane-closure-request-list");
			} else {
				this.$router.push(lastPage.path);
			}
		},
		goToReportClosure() {
			if (this.$route.params) {
				if (this.$route.params.id) {
					// this.$router.push("/lane-closure-request/"+this.$route.params.id+"/view?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					this.$router.push({ name: "ReportClosure", params: { id: this.$route.params.id } });
				}
			}
		},
		setLcrDateRange(dates) {
			this.lcrFromDate.value = dates.fromDate;
			this.lcrToDate.value = dates.toDate;
		},
		onFilterMap() {
			if (this.showNearby == "true") {
				this.$store.dispatch("map/loadNearby", {  });
			} else {
				this.$store.dispatch("map/hideNearby", {  });
			}
		},

		loadingMap(state) {
			this.isLoadingMap = state;
		},
		onSetMapDateFields(type) {
			var fromDate = Vue.prototype.moment();
			var toDate = Vue.prototype.moment();
			if (type == "today") {
				fromDate.hours(0);
				fromDate.minutes(0);
				fromDate.seconds(0);
				toDate.hours(23);
				toDate.minutes(59);
				toDate.seconds(59);
			}
			if (type == "today-3days") {
				fromDate.hours(0);
				fromDate.minutes(0);
				fromDate.seconds(0);
				toDate.hours(23);
				toDate.minutes(59);
				toDate.seconds(59);
				fromDate = Format.subtractWeekdays(fromDate, 3);
				toDate = Format.addWeekdays(toDate, 3);
			}
			if (type == "yesterday") {
				fromDate = fromDate.add(-1, 'days');
				toDate = toDate.add(-1, 'days');
				fromDate.hours(0);
				fromDate.minutes(0);
				fromDate.seconds(0);
				toDate.hours(23);
				toDate.minutes(59);
				toDate.seconds(59);
			}
			if (type == "lcr") {
				if (this.$store.getters['map/lcrFromDate'] != null && this.$store.getters['map/lcrToDate'] != null) {
					fromDate = this.$store.getters['map/lcrFromDate'];
					toDate = this.$store.getters['map/lcrToDate'];
					fromDate.hours(0);
					fromDate.minutes(0);
					fromDate.seconds(0);
					toDate.hours(23);
					toDate.minutes(59);
					toDate.seconds(59);
					this.lcrFromDate.value = fromDate.format();
					this.lcrToDate.value = toDate.format();
				}
			}
			if (type != "all") {
				this.mapFromDate.value = fromDate.format();
				this.mapToDate.value = toDate.format();
			} else {
				this.$store.dispatch("map/filterByDateRange", { fromDate: null, toDate: null });
				this.mapFromDate.value = null;
				this.mapToDate.value = null;
			}
		},
		onDateRangeSelect(date) {
		    if (date.startDate == null || date.endDate == null) {
		    	this.$store.dispatch("map/filterNearbyDateRange", {
		    		fromDate: null,
		    		toDate: null
		    	});
		    } else {
		    	let startMoment = this.moment(date.startDate);
		    	let endMoment = this.moment(date.endDate);

		    	if (startMoment.isValid()) {
		    	    startMoment.hours(0);
		    	    startMoment.minutes(0);
		    	    startMoment.seconds(0);
		    	}
		    	if (endMoment.isValid()) {
		    	    endMoment.hours(23);
		    	    endMoment.minutes(59);
		    	    endMoment.seconds(59);
		    	}
			this.$store.dispatch("map/filterNearbyDateRange", {
				fromDate: startMoment,
				toDate: endMoment
			});
			}

		},

		onMapDateFilter(type) {
			var fromDate = Vue.prototype.moment();
			var toDate = Vue.prototype.moment();
			if (type == "today") {
				fromDate.hours(0);
				fromDate.minutes(0);
				fromDate.seconds(0);
				toDate.hours(23);
				toDate.minutes(59);
				toDate.seconds(59);
				this.$store.dispatch("map/filterByDateRange", { fromDate: fromDate, toDate: toDate });
			}
			if (type == "today-3days") {
				fromDate.hours(0);
				fromDate.minutes(0);
				fromDate.seconds(0);
				toDate.hours(23);
				toDate.minutes(59);
				toDate.seconds(59);
				fromDate = Format.subtractWeekdays(fromDate, 3);
				toDate = Format.addWeekdays(toDate, 3);
				this.$store.dispatch("map/filterByDateRange", { fromDate: fromDate, toDate: toDate });
			}
			if (type == "yesterday") {
				fromDate = fromDate.add(-1, 'days');
				toDate = toDate.add(-1, 'days');
				fromDate.hours(0);
				fromDate.minutes(0);
				fromDate.seconds(0);
				toDate.hours(23);
				toDate.minutes(59);
				toDate.seconds(59);
				this.$store.dispatch("map/filterByDateRange", { fromDate: fromDate, toDate: toDate });
			}
			if (type == "lcr") {
				if (this.$store.getters['map/fromDate'] != null && this.$store.getters['map/toDate'] != null) {
					fromDate = this.$store.getters['map/fromDate'];
					toDate = this.$store.getters['map/toDate'];
				}
			}
			if (type != "all") {
				this.mapFromDate.value = fromDate.format();
				this.mapToDate.value = toDate.format();
			} else {
				this.$store.dispatch("map/filterByDateRange", { fromDate: null, toDate: null });
				this.mapFromDate.value = null;
				this.mapToDate.value = null;
			}
		},
		filterByMapDateRange(range) {
		},
		setPlace(place) {
			this.hasMapSearchTerms = true;
			let searchloc = new google.maps.Marker({
				position: place.geometry.location,
				map: this.$store.state.map.map,
				title: place.name,
				icon: {
					className: "user-marker",
					iconUrl: './assets/marker-user.svg',
					iconRetinaUrl: './assets/marker-user.svg',
					iconSize: [40, 40],
					iconAnchor: [30, 30], // iconSize/2 + padding
					shadowUrl: './assets/marker-shadow.svg',
					shadowRetinaUrl: './assets/marker-shadow.svg',
					shadowSize: [40, 40],
					shadowAnchor: [30, 30],
					shadowAngle: 0,
					iconAngle: 0,
					isUserIcon: true
				}
			});
			this.$store.commit('map/setSearchLocation', searchloc);
			this.$store.dispatch("map/zoomToSearchLocation", null);
		},

		onClearPlace() {
			this.hasMapSearchTerms = false;
			this.mapSearchStreet = null;
			this.$store.commit('map/setSearchLocation', null);
			// this.$store.dispatch("map/zoomToSearchLocation", null);
		},

		onHideMap() {
			Vue.prototype.$bus.$emit("map:toggle", 0);
		},

		toggleProfileMenu() {
			this.showProfileMenu = !this.showProfileMenu
			this.$nextTick(() => {
				if (this.showProfileMenu) {
					window.addEventListener('click', this.clickOutsideProfileMenuDisplay);
				}
				else {
					window.removeEventListener('click', this.clickOutsideProfileMenuDisplay);
				}
			});
		},
		clickOutsideProfileMenuDisplay(e) {
			let notificationWindow = document.getElementById('popover-profile-menu');
			let popupButton = document.getElementById('show-profile-button');
			let keepOpen = false;
			if (notificationWindow) {
				// if (notificationWindow.contains(e.target)) {
				// 	keepOpen = true;
				// }
				if (popupButton) {
					if (popupButton.contains(e.target)) {
						keepOpen = true;
					}
				}
				if (!keepOpen) {
					this.hideProfileMenuDisplay();
				}
			}
		},
		hideProfileMenuDisplay() {
			if (this.showProfileMenu) {
				this.showProfileMenu = false;
				window.removeEventListener('click', this.clickOutsideProfileMenuDisplay);
			}
		},

		onCenterMap() {
			this.$store.dispatch("map/zoomAllBlocks", null);
		},

		onNearby() {
			//
		},
		setLcrId(data) {
			this.lcrId = data.lcrId;
		},
		loadNearby() {
			this.isLoadingMap = true;
			this.$nextTick(() => {
			this.$store.dispatch("map/loadNearby", {  }).then(() => {
							this.$store.dispatch("map/setZindexesForPolylines");
						// this.isLoadingMap = false;

						});
			this.showNearby = true;
			});
		},

		loadNearbyBounded(boundaries) {
			if (!this.isLoadingMap) {
				this.isLoadingMap = true;
				this.$store.dispatch("map/loadNearbyBounded", boundaries).then(() => {
								this.$store.dispatch("map/setZindexesForPolylines");
								this.isLoadingMap = false;
							});
				this.showNearby = true;
			}
		},



		hideNearby() {
			this.$store.dispatch("map/hideNearby", {  });
			this.showNearby = false;
		},
		toggleNearby() {
			if (this.showNearby == "true") {
				this.$store.dispatch("map/loadNearby", {  });
			} else {
				this.$store.dispatch("map/hideNearby", {  });
			}
		},

		attachPolygonInfoWindow(polygon, coors, html) {

			polygon.infoWindow = new google.maps.InfoWindow({
				content: html
			});
			polygon.infoWindow.setPosition(coors);

			google.maps.event.addListener(polygon, 'mouseover', function() {
				polygon.infoWindow.open(this.map, polygon);
			});
			google.maps.event.addListener(polygon, 'mouseout', function() {
				polygon.infoWindow.close();
			});
		},

		blockPopup(popup) {
			if (this.map.infoWindow) {
				this.map.infoWindow.setMap(null);
			}
			this.infoWindowHtml = "";
			// let blockSwitcher = "";
			let x = 0;
			// let z = 0;
			let xx = 0;
			let polyline = null;
			let selected = false;
			let found = 0;
			// let lcrId = null;
			let testId = null;
			// let activeLcrId = this.$store.getters["map/activeLcrId"];
			let thisBlockIds = [];

			// set the colours of any polylines..
			for (xx =0; xx < this.$store.getters["map/polylines"].length; xx++) {
				this.$store.dispatch('map/setBlockPolylineColour', xx);
			}
			// set the colours of any nearby polylines..
			for (xx =0; xx < this.$store.getters["map/nearbyPolylines"].length; xx++) {
				this.$store.dispatch('map/setNearbyBlockPolylineColour', xx);
			}

			// find out the blocks that are touching...
			for (xx =0; xx < this.$store.getters["map/polylines"].length; xx++) {
				this.$store.dispatch('map/setBlockPolylineColour', xx);
				if (this.$store.getters["map/polylines"][xx].blockData) {
					if (this.$store.getters["map/polylines"][xx].laneClosureRequest) {
						if (this.$store.getters["map/polylines"][xx].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
							thisBlockIds.push(this.$store.getters["map/polylines"][xx].blockData.blockId);
							// this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#000000'});
						}
					}
				}
			}


			let overlapLcr = [];

			if (popup.polyline) {
				// popup.polyline.setOptions({strokeColor:'#000000'});
			} else {
				return;
			}
			for (xx =0; xx < thisBlockIds.length; xx++) {
				for (x =0; x <  this.$store.getters["map/polylines"].length; x++) {
					if (this.$store.getters["map/polylines"][x].blockData.blockId == thisBlockIds[xx]) {
						if (this.$store.getters["map/polylines"][x].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
							testId = this.$store.getters["map/polylines"][x].laneClosureRequest.id;
							if (overlapLcr.findIndex(z => z.id === testId) == -1 ) {
								overlapLcr.push({strokeColor:"#293C7C",textColor:"#ffffff", x:x, id:this.$store.getters["map/polylines"][x].laneClosureRequest.id, trafficManagementRef:this.$store.getters["map/polylines"][x].laneClosureRequest.trafficManagementRef, conflicts:this.$store.getters["map/polylines"][x].laneClosureRequest.conflicts});
							}
							this.$store.dispatch('map/setBlockPolylineColour', x);
							this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#293C7C'});

						}
					}
				}
			}

			// now loop through and find all requests with the same block ids.
			for (xx =0; xx < thisBlockIds.length; xx++) {
				for (x =0; x <  this.$store.getters["map/polylines"].length; x++) {
					if (this.$store.getters["map/polylines"][x].blockData.blockId == thisBlockIds[xx]) {
						if (this.$store.getters["map/polylines"][x].laneClosureRequest.id != popup.polyline.laneClosureRequest.id) {
							testId = this.$store.getters["map/polylines"][x].laneClosureRequest.id;
							if (overlapLcr.findIndex(z => z.id === testId) == -1 ) {
								overlapLcr.push({strokeColor:this.$store.getters["map/polylines"][x].strokeColor, textColor: this.$store.getters["map/polylines"][x].textColor, x:x, id:this.$store.getters["map/polylines"][x].laneClosureRequest.id, trafficManagementRef:this.$store.getters["map/polylines"][x].laneClosureRequest.trafficManagementRef, conflicts:this.$store.getters["map/polylines"][x].laneClosureRequest.conflicts});
							}
						}
					}
				}
			}


			overlapLcr.sort((a, b) => {
			let fa = a.trafficManagementRef;
			let fb = b.trafficManagementRef;
			let ia = a.id;
			let ib = b.id;
			if (fa == null && fb != null) {
				return 1;
			}
			if (fb == null && fa != null) {
				return -1;
			}

			if (fb == null && fa == null) {
				if (ia < ib) {
				return -1;
				}
				if (ia > ib) {
				return 1;
				}
				return 0;
			}

			if (fa < fb) {
			return -1;
			}
			if (fa > fb) {
			return 1;
			}
			return 0;
			});


			/*
			// here are the blocks...
			blockSwitcher = "";
			for (xx = 0; xx < overlapLcr.length; xx++) {
				if (overlapLcr[xx].id == popup.polyline.laneClosureRequest.id) {
					blockSwitcher += "<button type='button' class='popup__blockTab active' style='border-color:"+ popup.polyline.strokeColor + "; background-color:"+ popup.polyline.strokeColor  +"; color:#ffffff;' id='blockButton"+overlapLcr[xx].x+"' onclick='popupRequest("+overlapLcr[xx].id+")'>";
				} else {
					blockSwitcher += "<button type='button' class='popup__blockTab'  style='border-color:"+ overlapLcr[xx].strokeColor + "; background-color:"+ overlapLcr[xx].strokeColor +"; color:"+ overlapLcr[xx].textColor +"'  id='blockButton"+overlapLcr[xx].x+"' onclick='popupRequest("+overlapLcr[xx].id+")'>";
				}
				let showId = null;
				showId =  overlapLcr[xx].trafficManagementRef;
				if (overlapLcr[xx].conflicts != null) {
					if (overlapLcr[xx].conflicts.length > 0) {
						blockSwitcher += "<span class='icon-alert-circle'></span> ";
					}
				}
				if (showId != null)  {
					blockSwitcher += "TM: " + showId;
					blockSwitcher += " (LCR: " + overlapLcr[xx].id + ")";
				} else {
					blockSwitcher += "LCR: " + overlapLcr[xx].id;
				}

				blockSwitcher += "</button>";
			}
			*/

			for (xx =0; xx < this.$store.getters["map/polylines"].length; xx++) {
				polyline = null;
				selected = false;
				if (this.$store.getters["map/polylines"][xx].blockData) {
					if (this.$store.getters["map/polylines"][xx].blockData.blockId == popup.polyline.blockData.blockId) {
						if (this.$store.getters["map/polylines"][xx].laneClosureRequest) {
							polyline = this.$store.getters["map/polylines"][xx];
							if (this.$store.getters["map/polylines"][xx].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
								selected = true;
								found++;
							}
						}
						if (polyline == null) {
							continue;
						}
						if (selected && found > 1) {
							continue;
						}
						/*
						if (typeof polyline.laneClosureRequest.id == "object") {
							lcrId = polyline.laneClosureRequest.id.getValue();
						} else {
							lcrId = polyline.laneClosureRequest.id;
						}
						*/
						this.infoWindowHtml = this.popupHtmlText(polyline, this.overlapLcr.length);
					}
				}
			}


			// this.infoWindowHtml = "<div class='popup__wrapper'>" + this.infoWindowHtml + "<div class='popup__switcher'>" + blockSwitcher  + "</div>" + "</div>";
			this.infoWindowHtml = "<div class='popup__wrapper'>" + this.infoWindowHtml + "</div>";
			this.popupE = popup.e;
			this.map.infoWindow = new google.maps.InfoWindow({
				position: popup.e.latLng,
				// pixelOffset:new google.maps.Size(0, -300),
				content: this.infoWindowHtml
			});

			this.$store.dispatch('map/bringLcrPolylinesToTop', popup.polyline.laneClosureRequest.id);
			// this.map.infoWindow.open(this.map);
		},

		// Displays the next/previous overlapping LCR.
		overlapBlockPopup(popup) {

			if (this.map.infoWindow) {
				this.map.infoWindow.setMap(null);
			}
			this.infoWindowHtml = "";
			let blockSwitcher = "";
			// let x = 0;
			let xx = 0;
			let polyline = null;
			let lcrIdIndex = null;
			// let latlng = null;
			// this.$store.commit("map/clearMarkers");
			for (xx =0; xx < this.$store.getters["map/polylines"].length; xx++) {
				this.$store.dispatch('map/setBlockPolylineColour', xx);
			}
			for (xx =0; xx < this.$store.getters["map/nearbyPolylines"].length; xx++) {
				this.$store.dispatch('map/setNearbyBlockPolylineColour', xx);
			}

			if (this.overlapLcr[popup.index]) {
				for (xx =0; xx < this.$store.getters["map/nearbyPolylines"].length; xx++) {
					if (this.$store.getters["map/nearbyPolylines"][xx].blockData) {
						if (this.$store.getters["map/nearbyPolylines"][xx].laneClosureRequest) {
							if (this.$store.getters["map/nearbyPolylines"][xx].laneClosureRequest.id == this.overlapLcr[popup.index].id) {
									this.$store.getters["map/nearbyPolylines"][xx].setOptions({strokeColor:'#293C7C'});
									lcrIdIndex = xx;
							} else {
									this.$store.dispatch('map/setNearbyBlockPolylineColour', xx);
							}
						}
					}
				}
			}
			if (lcrIdIndex != null) {
				xx = lcrIdIndex;
				this.$store.dispatch('map/bringLcrNearbyPolylinesToTop', {lcrId:this.$store.getters["map/nearbyPolylines"][xx].laneClosureRequest.id, routeName:this.$router.currentRoute.name});
				// we found the lcr we need to popup information.
				polyline = this.$store.getters["map/nearbyPolylines"][xx];
				this.infoWindowHtml = this.popupHtmlText(polyline, this.overlapLcr.length);
				// let polyBounds = polyline.getPath();
				// if (polyBounds) {
				// 	let z = 0;
				// 	for (z = 0; z < polyBounds.length; z++) {
				// 		latlng =  google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng());
				// 	}
				// }
			} else {
				this.infoWindowHtml += "<div class='popup__block active' id='blockTab"+xx+"'>";
				this.infoWindowHtml += "Can't find the lcr: " + popup.index;
				this.infoWindowHtml += "</div>";
			}

			blockSwitcher = "";
			if (this.overlapLcr.length > 1) {
				let next = popup.index + 1;
				let prev = popup.index - 1;
				if (next > this.overlapLcr.length -1) {
					next = 0;
				}
				if (prev < 0) {
					prev = this.overlapLcr.length - 1;
				}
				if (prev < 0) prev = 0;
				if (next > this.overlapLcr.length) next = 0;

				blockSwitcher += "<button type='button' class='popup__prev'  onclick='popupOverlapRequest("+prev+")'> Prev";
				blockSwitcher += "</button>";

				blockSwitcher += "<span class='popup__page'>" + ( popup.index + 1) + " of " +  this.overlapLcr.length + " Requests</span>";

				blockSwitcher += "<button type='button' class='popup__next'  onclick='popupOverlapRequest("+next+")'>";
				blockSwitcher += " Next</button>";
			}
			let hasSwitcherClass = "";
			if (blockSwitcher != "") {
				hasSwitcherClass = " popup__wrapper--multiple";
				blockSwitcher =  "<div class='popup__switcher'>" + blockSwitcher  + "</div>" ;
			}
			this.infoWindowHtml = "<div class='popup__wrapper " + hasSwitcherClass + "'>" + blockSwitcher + this.infoWindowHtml  + "</div>";
			// this.infoWindowHtml = "<div class='popup__wrapper'>" + this.infoWindowHtml + "</div>";
			this.popupE = popup.e;

			this.map.infoWindow = new google.maps.InfoWindow({
				position: popup.e.latLng,
				// pixelOffset:new google.maps.Size(0, -300),
				content: this.infoWindowHtml
			});
			// new google.maps.Marker({
			//   position: latlng,
			//   map:this.map,
			//   title: "2",
			// });
			//this.map.infoWindow.open(this.map);

			if (lcrIdIndex != null)  {
				let id = this.$store.getters["map/nearbyPolylines"][lcrIdIndex].laneClosureRequest.id;
				var bounds = this.$store.getters["map/map"].getBounds();
				let setBounds = false;
				let x = 0;

				for (x = 0; x < this.$store.getters["map/nearbyPolylines"].length; x++) {
					if (this.$store.getters["map/nearbyPolylines"][x]) {
						if (this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest) {
							if (this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id == id) {
								let polyBounds = this.$store.getters["map/nearbyPolylines"][x].getPath();
								for (let z = 0; z < polyBounds.length; z++) {
									if (!bounds.contains(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()))){
										bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
										setBounds = true;
									}
								}
							}
						}
					}
				}
				if (setBounds) {
					this.$store.commit('map/fitBounds', bounds);
				}
			}

		},

		popupHtmlText(polyline, numberOverlapping) {
			let text = "";
			if (polyline) { // eslint-disable-line
			} else {
				return null;
			}

			let activeLcrId = this.$store.getters["map/activeLcrId"];

			text += "<div class='popup__block active'>";
			// text += "<div class='row'>";
			// text += "<div class='col popup__lcrid'>";

			// if (polyline.laneClosureRequest.isEmergency) {
			// 	text += "Emergency ";
			// }
			// if (polyline.laneClosureRequest.trafficManagementRef) {
			// 	text += "TM: " + polyline.laneClosureRequest.trafficManagementRef + "  ";
			// } else {
			// 	text += "LCR: " + polyline.laneClosureRequest.id;
			// }
			// text += "</div>";
			// text += "</div>";
			let affectedStreet = polyline.laneClosureRequest.affectedStreet;
			if (typeof polyline.laneClosureRequest.affectedStreet == "object") {
				affectedStreet = polyline.laneClosureRequest.affectedStreet.getValue();
			}

			let directionId = polyline.laneClosureRequest.directionId;
			if (typeof polyline.laneClosureRequest.directionId == "object") {
				directionId = polyline.laneClosureRequest.directionId.getValue();
			}
			let direction = LaneClosureRequest.getDirectionAbbreviationText(directionId);

			let firstCrossStreet = polyline.laneClosureRequest.firstCrossStreet;
			if (typeof polyline.laneClosureRequest.firstCrossStreet == "object") {
				firstCrossStreet = polyline.laneClosureRequest.firstCrossStreet.getValue();
			}
			let lastCrossStreet = polyline.laneClosureRequest.lastCrossStreet;
			if (typeof polyline.laneClosureRequest.lastCrossStreet == "object") {
				lastCrossStreet = polyline.laneClosureRequest.lastCrossStreet.getValue();
			}

			let natureOfWorkId = polyline.laneClosureRequest.natureOfWorkId;
			if (typeof polyline.laneClosureRequest.natureOfWorkId == "object") {
				natureOfWorkId = polyline.laneClosureRequest.natureOfWorkId.getValue();
			}
			lastCrossStreet += " for " + LaneClosureRequest.getNatureOfWorkTextEffect(natureOfWorkId);

			let isViewed = "";


			if (polyline.laneClosureRequest.id == activeLcrId && activeLcrId != null) {
				if (numberOverlapping > 1) {
					isViewed = "<span class='popup_is-viewed-lcr'>(Selected Request)</span>";
				}
			}

			text += "<div class='row'>";
			text += "<div class='col popup__affected text-primary'>" + direction + " " + affectedStreet + isViewed + "</div>";
			text += "</div>";
			text += "<div class='row'>";
			text += "<div class='col popup__value'>" + firstCrossStreet + " to " + lastCrossStreet ;



			let fromDate = polyline.laneClosureRequest.fromDate;
			if (typeof polyline.laneClosureRequest.fromDate == "object") {
				fromDate = polyline.laneClosureRequest.fromDate.getRawValue();
			}
			let toDate = polyline.laneClosureRequest.toDate;
			if (typeof polyline.laneClosureRequest.toDate == "object") {
				toDate = polyline.laneClosureRequest.toDate.getRawValue();
			}
			// text += "<div class='row'>";
			// if (moment(fromDate).format('MM/D/yyyy')  == moment(toDate).format('MM/D/yyyy')) {
			// 	text += "<div class='col popup__value'>" + moment(fromDate).format('MM/D/yyyy') +  "</div>";
			// } else {
			// 	text += "<div class='col popup__value'>" + moment(fromDate).format('MM/D/yyyy') + " - " + moment(toDate).format('MM/D/yyyy') +  "</div>";
			// }
			// text += "</div>";
			// text += "<div class='row'>";
			// text += "<div class='col popup__value'>" + moment(fromDate).format('H:mm') + " - " + moment(toDate).format('H:mm')  +  "</div>";
			// text += "</div>";

			text += "<br/>";

			if (Format.toLocalDateTime(fromDate, 'MM/D/YYYY') == Format.toLocalDateTime(toDate, 'MM/D/YYYY')) {
					text += Format.toLocalDateTime(fromDate, 'MM/D/YYYY') + "<br/>";
			} else {
					text += Format.toLocalDateTime(fromDate, 'MM/D/YYYY') + " - " + Format.toLocalDateTime(toDate, 'MM/D/YYYY') + "<br/>";
			}
			text += Format.toLocalDateTime(fromDate, 'H:mm') + " - " + Format.toLocalDateTime(toDate, 'H:mm');


			let isUnderTwoHours = polyline.laneClosureRequest.isUnderTwoHours;
			if (typeof polyline.laneClosureRequest.isUnderTwoHours == "object") {
				isUnderTwoHours = polyline.laneClosureRequest.isUnderTwoHours.getRawValue();
			}
			if (isUnderTwoHours == 1) {
				text += "<br/><span class='badge bg-two-hours'>2 hours</span>";
			}
			text += "</div>";
			text += "</div>";


			// Status
			let approvalStatusId = null;
			if (polyline.laneClosureRequest.approvalStatusId) {
				approvalStatusId = polyline.laneClosureRequest.approvalStatusId;
				if (typeof polyline.laneClosureRequest.approvalStatusId == "object") {
					approvalStatusId = polyline.laneClosureRequest.approvalStatusId.getRawValue();
				}
			}
			let recordStatusId = null;
			if (polyline.laneClosureRequest.recordStatusId) {
				recordStatusId = polyline.laneClosureRequest.recordStatusId;
			}
			if (typeof polyline.laneClosureRequest.recordStatusId == "object") {
				recordStatusId = polyline.laneClosureRequest.recordStatusId.getRawValue();
			}

			let approvalText = LaneClosureRequest.getApprovalStatusIdText(approvalStatusId);
			let recordText = LaneClosureRequest.getRecordStatusText(recordStatusId);
			let statusText = "";
			if (approvalText == recordText) {
				statusText = approvalText;
			} else {
				statusText = recordText + " - " + approvalText;
			}
			if (approvalStatusId == 1) {
					statusText = " <span class='popup__pending'>Pending</span>" + recordText;
			} else {
				if (recordStatusId == 6) {
					statusText =" <span class='popup__expired'>Expired</span> " + approvalText;
				} else {
					if (approvalStatusId == 2 && recordStatusId == 5) {
						if (polyline.laneClosureRequest.closureActiveStatusId == 2 || polyline.laneClosureRequest.restrictionActiveStatusId == 2) {
							statusText = " <span class='popup__active'>Active</span>" + statusText;
						} else {
							if (polyline.laneClosureRequest.closureActiveStatusId == 1 || polyline.laneClosureRequest.restrictionActiveStatusId == 1) {
								statusText = " <span class='popup__upcoming'>Upcoming</span>" + statusText;
							}
						}
					}
				}
			}



			text += "<div class='row'>";
			text += "<div class='col popup__status'>" + statusText ;
			if (polyline.laneClosureRequest.isEmergency) {
				text += " Emergency ";
			}

			if (polyline.laneClosureRequest.trafficManagementRef) {
				if (polyline.laneClosureRequest.trafficManagementRef.value) {
					text += " TM: " + polyline.laneClosureRequest.trafficManagementRef.value + "  ";
				} else {
					text += " TM: " + polyline.laneClosureRequest.trafficManagementRef + "  ";
				}
			} else {
				if (polyline.laneClosureRequest.id.value) {
					text += " LCR: " + polyline.laneClosureRequest.id.value;
				} else {
					text += " LCR: " + polyline.laneClosureRequest.id;
				}
			}
			text += "</div>";
			text += "</div>";


			let trafficEffect = null;

			if (polyline.laneClosureRequest.trafficEffect) {
				if (typeof polyline.laneClosureRequest.trafficEffect == "object") {
					trafficEffect = polyline.laneClosureRequest.trafficEffect.getRawValue();
				} else {
					trafficEffect = polyline.laneClosureRequest.trafficEffect;
				}
			}
			if (trafficEffect) {
				text += "<div class='row'>";
				text += "<div class='col popup__traffic-field'>Traffic Effect</div>";
				text += "</div>";
				text += "<div class='row'>";
				text += "<div class='col popup__traffic-value'>" + trafficEffect + "</div>";
				text += "</div>";
			}


			// not showing conflicts for now...
			if (polyline.laneClosureRequest.conflicts != null) {
				if (polyline.laneClosureRequest.conflicts.length > 0) {
					polyline.laneClosureRequest.conflictsFromOthers = polyline.laneClosureRequest.conflicts.filter(entry => {
						if (entry.requesterId !== polyline.laneClosureRequest.requesterId) {
							return true;
						}
					});
					if (polyline.laneClosureRequest.conflictsFromOthers.length > 0) {
					text += "<div class='row'>";
					text += "<div class='col popup__conflicts-field'>Conflicts</div>";
					text += "</div>";
					text += "<div class='row'>";
					text += "<div class='col popup__conflicts-value'>";
					for (var y = 0; y < polyline.laneClosureRequest.conflictsFromOthers.length; y++ ){
						text += "<button type='button' class='popup__blockTab popup__conflict'  style='' onclick='popupRequest("+polyline.laneClosureRequest.conflictsFromOthers[y].id+")'>";
						if (polyline.laneClosureRequest.conflictsFromOthers[y].conflictType == "duration") {
							if (polyline.laneClosureRequest.conflictsFromOthers[y].trafficManagementRef > 0) {
								text += "<span class='icon-alert-circle'></span> Duration Conflict with TM: " + polyline.laneClosureRequest.conflictsFromOthers[y].trafficManagementRef;
							} else {
								text += "<span class='icon-alert-circle'></span> Duration Conflict with LCR: " + polyline.laneClosureRequest.conflictsFromOthers[y].id;
							}
						}
						if (polyline.laneClosureRequest.conflictsFromOthers[y].conflictType == "adjacent_start_date") {
							if (polyline.laneClosureRequest.conflictsFromOthers[y].trafficManagementRef > 0) {
								text += "<span class='icon-alert-circle'></span> Adjacent Start Date with TM: " + polyline.laneClosureRequest.conflictsFromOthers[y].trafficManagementRef;
							} else {
								text += "<span class='icon-alert-circle'></span> Adjacent Start Date with LCR: " + polyline.laneClosureRequest.conflictsFromOthers[y].id;
							}
						}

						if (polyline.laneClosureRequest.conflictsFromOthers[y].conflictType == "adjacent_end_date") {
							if (polyline.laneClosureRequest.conflictsFromOthers[y].trafficManagementRef > 0) {
								text += "<span class='icon-alert-circle'></span> Adjacent Completion Date with TM: " + polyline.laneClosureRequest.conflictsFromOthers[y].trafficManagementRef;
							} else {
								text += "<span class='icon-alert-circle'></span> Adjacent Completion Date with LCR: " + polyline.laneClosureRequest.conflictsFromOthers[y].id;
							}
						}
						text += "</button>";
						/*
						for (var yy = 0; yy < this.$store.getters["map/nearbyPolylines"].length; yy++) {
							var conflictingPolyline = this.$store.getters["map/nearbyPolylines"][yy];
							if (conflictingPolyline.id == polyline.laneClosureRequest.conflicts[y].id) {

								if (activeLcrId == polyline.laneClosureRequest.conflicts[y].id) {
									blockSwitcher += "<button type='button' class='popup__blockTab'  style='border-color:"+ "#000044;" +"'  id='blockButton"+xx+"' onclick='popupRequest("+polyline.laneClosureRequest.conflicts[y].id+")'>";
								} else {
									blockSwitcher += "<button type='button' class='popup__blockTab'  style='border-color:"+ conflictingPolyline.strokeColor +"; color:#fff; background-color:" + conflictingPolyline.strokeColor + "'  id='blockButton"+xx+"' onclick='popupRequest("+polyline.laneClosureRequest.conflicts[y].id+")'>";
								}

								let showId = null;
								if (typeof conflictingPolyline.laneClosureRequest.trafficManagementRef == "object") {
									showId =  conflictingPolyline.laneClosureRequest.trafficManagementRef.getValue();
								} else {
									showId =  conflictingPolyline.laneClosureRequest.trafficManagementRef;
								}
								if (showId != null)  {
									blockSwitcher += "TM: " + showId;
									blockSwitcher += " (LCR: " + lcrId + ")";
								} else {
									blockSwitcher += "LCR: " + lcrId;
								}
								blockSwitcher += "</button>";
							}
						}
						*/
					}
					text += "</div>";
					text += "</div>";
				}
			}
			}
			if (polyline.laneClosureRequest.id != null) {
				if (polyline.laneClosureRequest.id == activeLcrId) {
					// text += "<div class='col popup__buttons'>";
					// text += ` <a onclick='goToLaneClosureRequestId(${polyline.laneClosureRequest.id})' class='link text-primary'>Details`;
					// text += "</a>";
					// text += "</div>";
					// if (numberOverlapping > 1) {
					// 	text += "<div class='row'>";
					// 	text += "<div class='col popup__buttons'>";
					// 	text += "<div class='popup__current-request'>This is the request you are currently viewing.</div>";
					// 	text += "</div>";
					// 	text += "</div>";
					// }
					text += "<div class='row'>";
					text += "<div class='col popup__buttons'>";
					text += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';
					text += "</div>";
					text += "</div>";


				} else {
					text += "<div class='row'>";
					text += "<div class='col popup__buttons'>";
					text += ` <button type='button' onclick='goToLaneClosureRequestId(${polyline.laneClosureRequest.id})' class='btn btn-secondary'>View Details`;
					text += "</button><br/><br/>";

					// text += ` <button type='button' onclick='goToBusMap()' class='btn'>Bus Stop/Parking Lots map</button>`;
					text += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';

					// text += '<a href="' + this.getMapBoundsBusStopLink() + '" class="btn" target="_blank">Bus Stop/Parking Lot Map</a>';

					text += "</div>";
					text += "</div>";
				}
			}

			text += "</div>";

			return text;
		},


		nearbyBlockPopup(popup) {
			if (this.map.infoWindow) {
				this.map.infoWindow.setMap(null);
			}
			this.infoWindowHtml = "";
			let blockSwitcher = "";
			let x = 0;
			let xx = 0;
			// let z = 0;
			let polyline = null;
			// let selected = false;
			// let found = 0;
			// let lcrId = null;
			// let activeLcrId = this.$store.getters["map/activeLcrId"];
			let thisBlockIds = [];
			let testId  = null;
			let lcrIdIndex = null;
			// this.$store.commit("map/clearMarkers");

			if (popup.polyline) { // eslint-disable-line
			} else {
				return;
			}
			Vue.prototype.$bus.$emit('map:exitIfFullScreen');
			for (xx =0; xx < this.$store.getters["map/polylines"].length; xx++) {
				this.$store.dispatch('map/setBlockPolylineColour', xx);
			}
			this.overlapLcr = [];

			// find out the blocks that are touching...
			if (this.$store.getters["map/nearbyPolylines"].length > 0) {
			for (xx =0; xx < this.$store.getters["map/nearbyPolylines"].length; xx++) {
				this.$store.dispatch('map/setNearbyBlockPolylineColour', xx);
				if (this.$store.getters["map/nearbyPolylines"][xx].blockData) {
					if (this.$store.getters["map/nearbyPolylines"][xx].laneClosureRequest) {
						if (this.$store.getters["map/nearbyPolylines"][xx].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
							thisBlockIds.push(this.$store.getters["map/nearbyPolylines"][xx].blockData.blockId);
							if (lcrIdIndex == null) {
								lcrIdIndex = xx;
							}
					}
				}
			}
			}

			// highlight this lane closure request's blocks
			for (xx =0; xx < thisBlockIds.length; xx++) {
				for (x =0; x <  this.$store.getters["map/nearbyPolylines"].length; x++) {
					if (this.$store.getters["map/nearbyPolylines"][x].blockData.blockId == thisBlockIds[xx]) {
						if (this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
							testId = this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id;
							if (this.overlapLcr.findIndex(z => z.id === testId) == -1 ) {
								this.overlapLcr.push({strokeColor:"#293C7C",textColor:"#ffffff", x:x, id:this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id, trafficManagementRef:this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.trafficManagementRef, conflicts:this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.conflicts});
							}
							this.$store.dispatch('map/setNearbyBlockPolylineColour', x);
							this.$store.getters["map/nearbyPolylines"][x].setOptions({strokeColor:'#293C7C'});
						}
					}
				}
			}
			// now loop through and find all requests with the same block ids.
			for (xx =0; xx < thisBlockIds.length; xx++) {
				for (x =0; x <  this.$store.getters["map/nearbyPolylines"].length; x++) {
					if (this.$store.getters["map/nearbyPolylines"][x].blockData.blockId == thisBlockIds[xx]) {
						if (this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id != popup.polyline.laneClosureRequest.id) {
							testId = this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id;
							if (this.overlapLcr.findIndex(z => z.id === testId) == -1 ) {
								this.overlapLcr.push({strokeColor:this.$store.getters["map/nearbyPolylines"][x].strokeColor, textColor: this.$store.getters["map/nearbyPolylines"][x].textColor, x:x, id:this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.id, trafficManagementRef:this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.trafficManagementRef, conflicts:this.$store.getters["map/nearbyPolylines"][x].laneClosureRequest.conflicts});
							}
						}
					}
				}
			}
			} else {
				for (xx =0; xx < this.$store.getters["map/polylines"].length; xx++) {
					this.$store.dispatch('map/setBlockPolylineColour', xx);
					if (this.$store.getters["map/polylines"][xx].blockData) {
						if (this.$store.getters["map/polylines"][xx].laneClosureRequest) {
							if (this.$store.getters["map/polylines"][xx].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
								thisBlockIds.push(this.$store.getters["map/polylines"][xx].blockData.blockId);
								if (lcrIdIndex == null) {
									lcrIdIndex = xx;
								}
							}
						}
					}
				}

				// highlight this lane closure request's blocks
				for (xx =0; xx < thisBlockIds.length; xx++) {
					for (x =0; x <  this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == thisBlockIds[xx]) {
							if (this.$store.getters["map/polylines"][x].laneClosureRequest.id == popup.polyline.laneClosureRequest.id) {
								testId = this.$store.getters["map/polylines"][x].laneClosureRequest.id;
								if (this.overlapLcr.findIndex(z => z.id === testId) == -1 ) {
									this.overlapLcr.push({strokeColor:"#293C7C",textColor:"#ffffff", x:x, id:this.$store.getters["map/polylines"][x].laneClosureRequest.id, trafficManagementRef:this.$store.getters["map/polylines"][x].laneClosureRequest.trafficManagementRef, conflicts:this.$store.getters["map/polylines"][x].laneClosureRequest.conflicts});
								}
								this.$store.dispatch('map/setBlockPolylineColour', x);
								this.$store.getters["map/polylines"][x].setOptions({strokeColor:'#293C7C'});
							}
						}
					}
				}
				// now loop through and find all requests with the same block ids.
				for (xx =0; xx < thisBlockIds.length; xx++) {
					for (x =0; x <  this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == thisBlockIds[xx]) {
							if (this.$store.getters["map/polylines"][x].laneClosureRequest.id != popup.polyline.laneClosureRequest.id) {
								testId = this.$store.getters["map/polylines"][x].laneClosureRequest.id;
								if (this.overlapLcr.findIndex(z => z.id === testId) == -1 ) {
									this.overlapLcr.push({strokeColor:this.$store.getters["map/polylines"][x].strokeColor, textColor: this.$store.getters["map/polylines"][x].textColor, x:x, id:this.$store.getters["map/polylines"][x].laneClosureRequest.id, trafficManagementRef:this.$store.getters["map/polylines"][x].laneClosureRequest.trafficManagementRef, conflicts:this.$store.getters["map/polylines"][x].laneClosureRequest.conflicts});
								}
							}
						}
					}
				}


			}





			this.overlapLcr.sort((a, b) => {
			let fa = a.trafficManagementRef;
			let fb = b.trafficManagementRef;
			let ia = a.id;
			let ib = b.id;
			if (fa == null && fb != null) {
				return 1;
			}
			if (fb == null && fa != null) {
				return -1;
			}

			if (fb == null && fa == null) {
				if (ia < ib) {
				return -1;
				}
				if (ia > ib) {
				return 1;
				}
				return 0;
			}

			if (fa < fb) {
			return -1;
			}
			if (fa > fb) {
			return 1;
			}
			return 0;
			});



			// here are the blocks...
			blockSwitcher = "";
			let overlapIndex = 0;

			for (xx = 0; xx < this.overlapLcr.length; xx++) {
				if (this.overlapLcr[xx].id == popup.polyline.laneClosureRequest.id) {
					//
					overlapIndex = xx;
					blockSwitcher += "<button type='button' class='popup__blockTab active' style='border-color:"+ popup.polyline.strokeColor + "; background-color:"+ popup.polyline.strokeColor  +"; color:#ffffff;' id='blockButton"+this.overlapLcr[xx].x+"' onclick='popupRequest("+this.overlapLcr[xx].id+")'>";
				} else {
					blockSwitcher += "<button type='button' class='popup__blockTab'  style='border-color:"+ this.overlapLcr[xx].strokeColor + "; background-color:"+ this.overlapLcr[xx].strokeColor +"; color:"+ this.overlapLcr[xx].textColor +"'  id='blockButton"+this.overlapLcr[xx].x+"' onclick='popupRequest("+this.overlapLcr[xx].id+")'>";
				}
				let showId = null;
				showId =  this.overlapLcr[xx].trafficManagementRef;
				if (this.overlapLcr[xx].conflicts != null) {
					if (this.overlapLcr[xx].conflicts.length > 0) {
						blockSwitcher += "<span class='icon-alert-circle'></span> ";
					}
				}
				if (showId != null)  {
					blockSwitcher += "TM: " + showId;
					blockSwitcher += " (LCR: " + this.overlapLcr[xx].id + ")";
				} else {
					blockSwitcher += "LCR: " + this.overlapLcr[xx].id;
				}

				blockSwitcher += "</button>";
			}


			if (lcrIdIndex == null) {
				// perhaps its in the map/polylines
			}

			this.infoWindowHtml =  "";
			xx = lcrIdIndex;
			polyline = null;
			// selected = false;

			if (this.$store.getters["map/nearbyPolylines"].length > 0) {
			if (this.$store.getters["map/nearbyPolylines"][xx]) {
				polyline = this.$store.getters["map/nearbyPolylines"][xx];
				this.infoWindowHtml = this.popupHtmlText(polyline, this.overlapLcr.length);
			}
			} else {
				if (this.$store.getters["map/polylines"][xx]) {
					polyline = this.$store.getters["map/polylines"][xx];
					this.infoWindowHtml = this.popupHtmlText(polyline, this.overlapLcr.length);
				}
			}


			blockSwitcher = "";
			if (this.overlapLcr.length > 1) {

				let next = overlapIndex + 1;
				let prev = overlapIndex - 1;

				if (next > this.overlapLcr.length -1) {
					next = 0;
				}
				if (prev < 0) {
					prev = this.overlapLcr.length - 1;
				}
				if (prev < 0) prev = 0;
				if (next > this.overlapLcr.length) next = 0;

				blockSwitcher += "<button type='button' class='popup__prev'  onclick='popupOverlapRequest("+prev+")'> Prev";
				blockSwitcher += "</button>";
				blockSwitcher += "<span class='popup__page'>" + ( overlapIndex + 1) + " of " +  this.overlapLcr.length + " Requests</span>";
				blockSwitcher += "<button type='button' class='popup__next'  onclick='popupOverlapRequest("+next+")'>";
				blockSwitcher += " Next</button>";
			}

			let hasSwitcherClass = "";
			if (blockSwitcher != "") {
				hasSwitcherClass = " popup__wrapper--multiple";
				blockSwitcher =  "<div class='popup__switcher'>" + blockSwitcher  + "</div>" ;
			}
			this.infoWindowHtml = "<div class='popup__wrapper " + hasSwitcherClass + "'>" + blockSwitcher + this.infoWindowHtml  + "</div>";

			// this.infoWindowHtml = "<div class='popup__wrapper'>" + "<div class='popup__switcher'>" + blockSwitcher  + "</div>" +this.infoWindowHtml +  "</div>";
			// this.infoWindowHtml = "<div class='popup__wrapper'>" + this.infoWindowHtml + "</div>";
			this.popupE = popup.e;

			// this.map.infoWindow = new Popup(
			//   popup.e.latLng,
			//   `${this.infoWindowHtml}`
			// );
			// this.map.infoWindow.setMap(this.map);

			this.map.infoWindow = new google.maps.InfoWindow({
				position: popup.e.latLng,
				// pixelOffset:new google.maps.Size(0, -300),
				content: this.infoWindowHtml
			});

			if (this.$store.getters["map/nearbyPolylines"].length > 0) {
				this.$store.dispatch('map/bringLcrNearbyPolylinesToTop', {lcrId:popup.polyline.laneClosureRequest.id, routeName:this.$router.currentRoute.name});
			} else {
				this.$store.dispatch('map/bringLcrPolylinesToTop', popup.polyline.laneClosureRequest.id);
			}

			// this.map.infoWindow.open(this.map);
		},

		infoWindowAddBlockHelp() {
			let html ="";

			html += "<div class='row'>";
			html += "<div class='col'>";
			html += "<p>Click on the map to add or remove street blocks from your request.</p>";
			html += "</div>";
			html += "</div>";
			return html;
		},


		infoWindowRemoveAllBlocksButton() {
			let html ="";
			html += ` <button type='button' onclick='removeAllBlocks()' class='btn btn-secondary mr-3'>Remove All Blocks</button>`;
			return html;
		},




		infoWindowSelectRequestBlock() {
			let html ="";
			html += "<div class='row'>";
			html += "<div class='col'>";
			html += "<p>Select a request from the listing or click on the map to view its details.</p>";
			html += "</div>";
			html += "</div>";
			return html;
		},

		// sets the info window html
		resetSideBar(showRemoveAllBlocks) {
			if (this.map.infoWindow) {
				this.map.infoWindow.setMap(null);
			}
			if (window.location.href.indexOf("new-lane-closure-request") != -1 ||
				window.location.href.indexOf("new-lane-closure-request-with-contravention") != -1 ||
				window.location.href.indexOf("/edit") != -1
			){
				this.infoWindowHtml = "";
				this.infoWindowHtml += "<div class='popup__wrapper'>";
				this.infoWindowHtml += "<div class='popup__block active'>";
				this.infoWindowHtml += this.infoWindowAddBlockHelp();
				this.infoWindowHtml += "<div class='row'>";
				this.infoWindowHtml += "<div class='col'>";
				this.infoWindowHtml += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';
				// if (showRemoveAllBlocks) {
					this.infoWindowHtml += this.infoWindowRemoveAllBlocksButton();
				// }
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
			} else {
				this.infoWindowHtml = "";
				this.infoWindowHtml += "<div class='popup__wrapper'>";
				this.infoWindowHtml += "<div class='popup__block active'>";
				this.infoWindowHtml = this.infoWindowSelectRequestBlock();
				this.infoWindowHtml += "<div class='row'>";
				this.infoWindowHtml += "<div class='col'>";
				this.infoWindowHtml += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
			}
		},

		blockPickerPopup(popup) {
			// document.form1.waypointLog.value = e.latLng.lat().toFixed(6)
			// + ' |' + e.latLng.lng().toFixed(6);
			// this.attachPolygonInfoWindow(polyline.block, polyline.e.latLng, "hmmmm");
			if (this.map.infoWindow) {
				this.map.infoWindow.setMap(null);
			}
			this.infoWindowHtml = "";

			this.infoWindowHtml += "<div class='row'>";
			this.infoWindowHtml += "<div class='col popup__field'>Selected Block #" + popup.polyline.blockData.blockId + "</div>";
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "<div class='row'>";
			let streetName = popup.polyline.blockData.streetName;
			if (typeof popup.polyline.blockData.streetName == "object") {
				streetName = popup.polyline.blockData.streetName.getValue();
			}
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "<div class='row'>";
			this.infoWindowHtml += "<div class='col popup__value text-primary'>";


			if (popup.polyline.blockData.directionId) {
				this.infoWindowHtml += LaneClosureRequest.getDirectionAbbreviationText(popup.polyline.blockData.directionId) + " ";
			}

			this.infoWindowHtml +=  streetName + " from "

			let fromStreet = popup.polyline.blockData.fromStreet;
			if (typeof popup.polyline.blockData.fromStreet == "object") {
				fromStreet = popup.polyline.blockData.fromStreet.getValue();
			}
			let toStreet = popup.polyline.blockData.toStreet;
			if (typeof popup.polyline.blockData.toStreet == "object") {
				toStreet = popup.polyline.blockData.toStreet.getValue();
			}
			this.infoWindowHtml +=  fromStreet + " to " + toStreet;
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "</div>";


			// this.infoWindowHtml += "<div class='row'>";
			// this.infoWindowHtml += "<div class='col popup__field'>Block ID "+popup.polyline.blockData.blockId+"</div>";
			// this.infoWindowHtml += "</div>";

			this.infoWindowHtml += "<div class='row'>";
			this.infoWindowHtml += "<div class='col popup__field text-primary'>";

			// this.infoWindowHtml += ` <button type='button' onclick='hideMapPopup()' class='btn btn-primary mr-2'>Close</button>`;
			this.infoWindowHtml += ` <button type='button' onclick='removeBlockId(${popup.polyline.blockData.blockId})' class='btn btn-secondary mr-3'>Remove Block</button>`;

			this.infoWindowHtml += this.infoWindowRemoveAllBlocksButton();

			this.infoWindowHtml += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mt-3 mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';


			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "</div>";

			this.infoWindowHtml += this.infoWindowAddBlockHelp();

			/*
			this.map.infoWindow = new google.maps.InfoWindow({
				position: popup.e.latLng,
				// pixelOffset:new google.maps.Size(0, -300),
				content: this.infoWindowHtml
			});
			// polyline.block.infoWindow.setPosition(polyline.e.latlng);
			this.map.infoWindow.open(this.map);
			*/
		},

		blockClosurePopup(popup) {
			Vue.prototype.$bus.$emit('map:exitIfFullScreen');
			if (this.map.infoWindow) {
				this.map.infoWindow.setMap(null);
			}
			this.infoWindowHtml = "";

			this.infoWindowHtml += "<div class='row'>";
			this.infoWindowHtml += "<div class='col popup__field'>Selected Block #" + popup.polyline.blockData.blockId + "</div>";
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "<div class='row'>";
			let streetName = popup.polyline.blockData.streetName;
			if (typeof popup.polyline.blockData.streetName == "object") {
				streetName = popup.polyline.blockData.streetName.getValue();
			}
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "<div class='row'>";
			this.infoWindowHtml += "<div class='col popup__value text-primary'>";


			if (popup.polyline.blockData.directionId) {
				this.infoWindowHtml += LaneClosureRequest.getDirectionAbbreviationText(popup.polyline.blockData.directionId) + " ";
			}

			this.infoWindowHtml +=  streetName + " from "

			let fromStreet = popup.polyline.blockData.fromStreet;
			if (typeof popup.polyline.blockData.fromStreet == "object") {
				fromStreet = popup.polyline.blockData.fromStreet.getValue();
			}
			let toStreet = popup.polyline.blockData.toStreet;
			if (typeof popup.polyline.blockData.toStreet == "object") {
				toStreet = popup.polyline.blockData.toStreet.getValue();
			}
			this.infoWindowHtml +=  fromStreet + " to " + toStreet;
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "</div>";


			// this.infoWindowHtml += "<div class='row'>";
			// this.infoWindowHtml += "<div class='col popup__field'>Block ID "+popup.polyline.blockData.blockId+"</div>";
			// this.infoWindowHtml += "</div>";

			this.infoWindowHtml += "<div class='row'>";
			this.infoWindowHtml += "<div class='col popup__field text-primary'>";

			this.infoWindowHtml += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mt-3 mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';
			this.infoWindowHtml += "</div>";
			this.infoWindowHtml += "</div>";
		},


		canAuditLog() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin') || this.$store.getters.userHasRole('internal_admin_reports')) {
				return true;
			}
			return false;
		},
		canOrganizationRequests() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')  || this.$store.getters.userHasRole('internal_admin_registration')) {
				return true;
			}
			return false;
		},
		canUserRequests() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin') || this.$store.getters.userHasRole('agency_admin')) {
				return true;
			}
			return false;
		},
		canGlobalSettings() {
			if (this.$store.getters.userHasRole('system_admin')) {
				return true;
			}
			return false;
		},
		addYourLocationButton: function() {
			var controlDiv = document.createElement('div')
			var firstChild = document.createElement('button')
			firstChild.style.backgroundColor = '#fff'
			firstChild.style.border = 'none'
			firstChild.style.outline = 'none'
			firstChild.style.width = '28px'
			firstChild.style.height = '28px'
			firstChild.style.borderRadius = '2px'
			firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
			firstChild.style.cursor = 'pointer'
			firstChild.style.marginRight = '10px'
			firstChild.style.padding = '0px'
			firstChild.title = 'Your Location'
			controlDiv.appendChild(firstChild)

			var secondChild = document.createElement('div')
			secondChild.style.margin = '5px'
			secondChild.style.width = '18px'
			secondChild.style.height = '18px'
			secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)'
			secondChild.style.backgroundSize = '180px 18px'
			secondChild.style.backgroundPosition = '0px 0px'
			secondChild.style.backgroundRepeat = 'no-repeat'
			secondChild.id = 'your_location_image'
			firstChild.appendChild(secondChild)
			let that = this;

			this.googleMap.maps.event.addListener(this.map, 'center_changed', function() {
				secondChild.style['background-position'] = '0 0'
				that.loadNearbyEntries();
			})

			this.googleMap.maps.event.addListener(this.map, 'zoom_changed', function() {
				that.showOrHideMarkers();
				that.loadNearbyEntries();
			})




			this.googleMap.maps.event.addListener(this.map, 'idle', function() {
			          // var bounds =  that.map.getBounds();
			          // that.mapZoom = that.map.getZoom();
			          // that.mapBoundsNE = bounds.getNorthEast();
			          // that.mapBoundsSW = bounds.getSouthWest();
			          // console.log(that.mapZoom);
			          // console.log(that.mapBoundsNE);
			          // var maxZoomService = new google.maps.MaxZoomService();
			          // maxZoomService.getMaxZoomAtLatLng(that.mapBoundsNE, (result) => {
			          //    console.log("max:"+result.zoom);
			          //  });

			          if (document.getElementById("globalBusStopMapLink")) {
			          	document.getElementById("globalBusStopMapLink").href= that.getMapBoundsBusStopLink();
			          }
			 });


			firstChild.addEventListener('click', function() {
				var imgX = '0'
				var animationInterval = setInterval(function() {
					if (imgX === '-18') imgX = '0'
					else imgX = '-18'
					if (document.getElementById('your_location_image')) {
						document.getElementById('your_location_image').style.backgroundPosition = '0px 0px'
					}
				}, 500)
				if (navigator.geolocation) {
					// this.compassPremissioniOS13$();
					navigator.geolocation.getCurrentPosition(function(position) {
						var latlng = new that.googleMap.maps.LatLng(position.coords.latitude, position.coords.longitude)
						let mylocation = new google.maps.Marker({
							position: latlng,
							map: that.$store.state.map.map,
							title: "My Location",
							icon: {
								className: "user-marker",
								url: './assets/marker-user.svg',
								iconRetinaUrl: './assets/marker-user.svg',
								size: new google.maps.Size(40, 40),
								iconAnchor: [30, 30], // iconSize/2 + padding
								shadowUrl: './assets/marker-shadow.svg',
								shadowRetinaUrl: './assets/marker-shadow.svg',
								shadowSize: [40, 40],
								shadowAnchor: [30, 30],
								shadowAngle: 0,
								iconAngle: 0,
								isUserIcon: true
							}
						});

						that.$store.commit('map/setMyLocation', mylocation);
						that.$store.dispatch("map/zoomToMyLocation", null);
						clearInterval(animationInterval)
						if (document.getElementById('your_location_image')) {
							document.getElementById('your_location_image').style.backgroundPosition = '-144px 0px'
						}
					})
				} else {
					clearInterval(animationInterval)
					if (document.getElementById('your_location_image')) {
						document.getElementById('your_location_image').style.backgroundPosition = '0px 0px'
					}
				}
			})
			controlDiv.index = 1
			this.map.controls[that.googleMap.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv)
		},
		addMapControlButtons: function() {
			let that = this;
			var controlDiv = document.createElement('div')



			/*
			var reCenterMapButton = document.createElement('button')
			reCenterMapButton.style.backgroundColor = '#fff'
			reCenterMapButton.style.border = 'none'
			reCenterMapButton.style.outline = 'none'
			reCenterMapButton.style.borderRadius = '2px'
			reCenterMapButton.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
			reCenterMapButton.style.cursor = 'pointer'
			reCenterMapButton.style.padding = '0px 17px'
			reCenterMapButton.style.color = 'rgb(86, 86, 86)'
			reCenterMapButton.style.fontFamily = 'Roboto, Arial, sans-serif'
			reCenterMapButton.style.fontSize = '18px'
			reCenterMapButton.style.height = '40px'
			reCenterMapButton.title = 'Center Map'
			reCenterMapButton.innerHTML = "Re-Center Map";
			reCenterMapButton.style.borderBottomLeftRadius = "2px";
			reCenterMapButton.style.borderTopLeftRadius = "2px";
			reCenterMapButton.style.boxShadow = "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px";

			this.googleMap.maps.event.addListener(this.map, 'center_changed', function() {})
			reCenterMapButton.addEventListener('click', function() {
				that.$store.dispatch("map/zoomAllBlocks", null);
			})
			controlDiv.index = 1

			var closeMapButton = document.createElement('button')
			closeMapButton.style.backgroundColor = '#293C7C'
			closeMapButton.style.border = 'none'
			closeMapButton.style.outline = 'none'
			closeMapButton.style.borderRadius = '2px'
			closeMapButton.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
			closeMapButton.style.cursor = 'pointer'
			closeMapButton.style.padding = '0px 17px'
			closeMapButton.style.color = '#fff'
			closeMapButton.style.fontFamily = 'Roboto, Arial, sans-serif'
			closeMapButton.style.fontSize = '18px'
			closeMapButton.style.height = '40px'
			closeMapButton.title = 'Hide Map'
			closeMapButton.innerHTML = "Hide Map";
			closeMapButton.style.marginLeft = '10px'
			closeMapButton.style.borderBottomRightRadius = "2px";
			closeMapButton.style.borderTopRightRadius = "2px";
			closeMapButton.style.borderBottomLeftRadius = "0px";
			closeMapButton.style.borderTopLeftRadius = "0px";
			closeMapButton.style.borderTopLeftWidth = "0";
			closeMapButton.style.borderTopLeftWidth = "0";
			closeMapButton.style.boxShadow = "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px";


			closeMapButton.innerHTML = "Hide Map";
			this.googleMap.maps.event.addListener(this.map, 'center_changed', function() {})
			closeMapButton.addEventListener('click', function() {
				Vue.prototype.$bus.$emit("map:toggle", 0);
			})
			*/

			var fullScreenMap = document.createElement('button')
			fullScreenMap.style.backgroundColor = '#fff'
			fullScreenMap.style.border = 'none'
			fullScreenMap.style.outline = 'none'
			fullScreenMap.style.borderRadius = '2px'
			fullScreenMap.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)'
			fullScreenMap.style.cursor = 'pointer'
			fullScreenMap.style.padding = '0px 17px'
			fullScreenMap.style.color = 'rgb(86, 86, 86)'
			fullScreenMap.style.fontFamily = 'Roboto, Arial, sans-serif'
			fullScreenMap.style.fontSize = '18px'
			fullScreenMap.style.height = '40px'
			fullScreenMap.title = 'Center Map'
			fullScreenMap.style.borderBottomLeftRadius = "2px";
			fullScreenMap.style.marginLeft = "10px";
			fullScreenMap.style.borderTopLeftRadius = "2px";
			fullScreenMap.style.boxShadow = "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px";
			fullScreenMap.innerHTML = "<span class='icon-maximize'></span>";
			fullScreenMap.addEventListener('click', function() {
				Vue.prototype.$bus.$emit("map:toggleFullScreen", null);
			})



			// controlDiv.appendChild(closeMapButton);
			// controlDiv.appendChild(reCenterMapButton);
			controlDiv.appendChild(fullScreenMap);


			this.map.controls[that.googleMap.maps.ControlPosition.LEFT_BOTTOM].push(controlDiv)

			// const tmLayer = new google.maps.KmlLayer("https://laneclosures.patternhosting.com/kml/traffic-management-map.xml", {
			// 	map:this.map
			//   });
			// tmLayer.setMap(this.map);




			// const transitLayer = new that.googleMap.maps.TransitLayer();
			// transitLayer.setMap(this.map);

			const styles = {
				default: [
				],
				hide: [
				{
					featureType: "poi.business",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "poi",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "administrative.locality",
					stylers: [{ visibility: "off" }]
				},
				{
					featureType: "transit.line",
					stylers: [{ visibility: "on" }]
				},
				{
					featureType: "transit.station.bus",
					stylers: [{ visibility: "on" }]
				},
				]
			};
			this.map.setOptions({ styles: styles["hide"] });

			this.$refs.mapRef.$mapPromise.then((map) => {
			})




		},

		loadNearbyEntries() {
			let that = this;
		if(that.$route.name == "ViewLaneClosureRequest") {
			if (!that.$store.getters["map/canLoadNearbyBounds"]) {
				// console.log("can't load nearby");
				return;
			} else {
				// console.log("try load nearby");
			}

			var newBounds =  that.map.getBounds();
			var oldBounds = null;
			if (that.$store) {
				if (that.$store.getters["map/nearbyBounds"] != null) {
					oldBounds = that.$store.getters["map/nearbyBounds"];
				}
			}

			if (oldBounds != null && newBounds != null) {
				let bounds = newBounds.toJSON();

				if (bounds.west < oldBounds.west ||
				bounds.south < oldBounds.south ||
				bounds.north > oldBounds.north ||
				bounds.east > oldBounds.east || 1 == 1
				) {
					let distance = that.$store.getters["map/nearbyRadius"] * 0.1 / 10000;  // 3 km around
					bounds.south = bounds.south - distance;
					bounds.north = bounds.north + distance;
					bounds.west = bounds.west - distance;
					bounds.east = bounds.east + distance;
					that.$store.commit("map/setNearbyBounds", bounds);

					clearTimeout(that.loadMapTimeout);
					that.loadMapTimeout =  setTimeout(function() {
						let bounds = that.$store.getters["map/nearbyBounds"];
					if (bounds != null) {
						let nbounds = {};
						nbounds.south = bounds.south;
						nbounds.east = bounds.east;
						nbounds.west = bounds.west;
						nbounds.north = bounds.north;

						let distance = that.$store.getters["map/nearbyRadius"] * 0.1 / 10000;  // 3 km around
						bounds.south = bounds.south - distance;
						bounds.north = bounds.north + distance;
						bounds.west = bounds.west - distance;
						bounds.east = bounds.east + distance;
						// console.log(bounds.south +","+ nbounds.south);
					}
						that.$store.dispatch("map/setNearbyBounds", bounds);
						Vue.prototype.$bus.$emit("map:loadNearbyBounded", bounds);
					}, 500);
				} else {
					// console.log("same");
					// console.log(bounds);
					// console.log(oldBounds);
				}



			}
			/*
			let bounds = this.$store.getters["map/bounds"].toJSON();
			let distance = this.$store.getters["map/nearbyRadius"] * 0.1 / 10000;  // 3 km around
			bounds.south = bounds.south - distance;
			bounds.north = bounds.north + distance;
			bounds.west = bounds.west - distance;
			bounds.east = bounds.east + distance;
			that.isLoadingMap = true;
			that.$store.dispatch("map/loadNearby", boundaries).then(() => {
							that.$store.dispatch("map/setZindexesForPolylines");
							that.isLoadingMap = false;
						});
			*/
		}


		},

		showOrHideMarkers() {
			let that = this;
			if (that.$store) {
				if (that.map.getZoom() < 16){
					that.$store.commit('map/clearOverlapIcons', {});
				} else {
					that.$store.commit('map/buildOverlapIcons', {});
				}
			}
		},


		trackMe() {

		    // compass listener (also ios13+ fallback at "compassPremissioniOS13" funtion)
		    if (typeof DeviceOrientationEvent['requestPermission'] !== 'function') {
		      const deviceOrientationLestener = (event) => {
		        if (this.globals.iphone) {
		          this.currentCompass$.next(event['webkitCompassHeading']);
		        } else {
		          if (event.absolute) {
		            this.currentCompass$.next(360 - event.alpha);
		          } else {
		            window.removeEventListener('deviceorientation', deviceOrientationLestener);
		            window.addEventListener('deviceorientationabsolute', (eventB) => {
		              this.currentCompass$.next(360 - eventB['alpha']);
		            }, true);
		          }
		        }
		      };
		      window.addEventListener('deviceorientation', deviceOrientationLestener);
		    }  else {
		      document.addEventListener('deviceready', () => {
		        navigator['compass'].watchHeading((head) => {
		          this.currentCompass$.next(head.trueHeading);
				}, (error) => console.log(error), {frequency: 10});  // eslint-disable-line
		      }, false);
		    }

		    // GET LOCATION - energy saving and preformance inhancing for mobile, dumm and cyclic for desktop.
		      document.addEventListener('deviceready', () => {
		        if (navigator.geolocation) {
		          navigator.geolocation.watchPosition((position) => {
		            this.currentLocation$.next(position.coords);
		            this.isCurrentPosition$.next(true);
		            this.sendLocationError = true;
		          }, (err) => {
		            this.isCurrentPosition$.next(false);
		            this.sendError(err.message);
		            this.errorMessage$ = err.message;
		          }, {
		            enableHighAccuracy: true
		          });
		        } else {
		          alert('Geolocation is not supported by this browser.');
		        }
		      }, false);
		  },


		  compassPremissioniOS13$() {
		      return new Promise((resolve, reject) => {
		        if (navigator.geolocation) {
		          if (typeof DeviceOrientationEvent['requestPermission'] === 'function') {
		            DeviceOrientationEvent['requestPermission']()
		              .then(permissionState => {
		                if (permissionState === 'granted') {
		                  window.addEventListener('deviceorientation', (event) => {
		                    this.currentCompass$.next(event['webkitCompassHeading']);
		                  });
		                  resolve('User accepted');
		                } else {
		                  reject('User declined');
		                }
		              })
					.catch(console.error); // eslint-disable-line
		          }
		        } else {
		          alert('deviceorientation is not supported by this browser.');
		          this.sendError('deviceorientation = null ("deviceorientation is not supported by this browser.")');
		        }
		      });
		    },

		locateMe() {
			let that = this;
			this.$getLocation({
					enableHighAccuracy: true, //defaults to false
					timeout: Infinity, //defaults to Infinity
					maximumAge: 0 //defaults to 0
				})
			.then(position => {
				that.$store.commit('map/myLocation', position);

				let latlng = new that.googleMap.maps.LatLng(
				parseFloat(position.coords.latitude),
				parseFloat(position.coords.longitude))
				this.center = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				}
				that.createMarker(latlng)

			});
		},
		createMarker: function(latlng) {
			this.marker = new this.googleMap.maps.Marker({
				setMap: this.map,
				position: latlng,
				animation: this.googleMap.maps.Animation.DROP
			})
		},
		showUnderDevelopmentModal(obj) {
			this.modalTitle = "Under Development";
			this.modalBody = "This feature is under development.";
			if (obj) {
				if (obj.title) {
					this.modalTitle = obj.title;
				}
				if (obj.body) {
					this.modalBody = obj.body;
				}
			}
			this.$refs['modal-under-development'].show();
		},
		hideUnderDevelopmentModal() {
			this.$refs['modal-under-development'].hide();
		},
		SetLocale(locale) {
			this.locale = this.$i18n.locale = localStorage.locale = locale;
			if (this.locale.indexOf("en") == 0) {
				Numeral.locale("en");
			}
			if (this.locale.indexOf("fr") == 0) {
				Numeral.locale("fr");
			}
		},
		ToggleLocale() {
			this.SetLocale(this.locale == 'en-CA' ? 'fr-CA' : 'en-CA');
		},
		onMapClick(e) {
			Vue.prototype.$bus.$emit('map:click', e);
		},

		onMapStreetInput(value, instance) {
			// plot it on the map.
			// let that= this;
			if (value) {
				if (value.lat != null && value.lng != null && value.label != null) {
					let latlng = new this.googleMap.maps.LatLng(
					parseFloat(value.lat),
					parseFloat(value.lng));
					// this.center = {
					// 	lat: parseFloat(value.lat),
					// 	lng: parseFloat(value.lng)
					// }

					// this.$refs.mapRef.$mapPromise.then((map) => {
					//   map.panTo({lat: 1.38, lng: 103.80})
					//   that.markerMapSearch = new that.googleMap.maps.Marker({
					//   	setMap: that.map,
					//   	position: latlng,
					//   	animation: that.googleMap.maps.Animation.DROP,
					//   	title:value.label,
					//   	optimized: false
					//   })
					//   console.log(that.markerMapSearch.position.lat());
					//   console.log(that.markerMapSearch.position.lng());
					// })

					this.hasMapSearchTerms = true;
					let searchloc = new google.maps.Marker({
						position: latlng,
						map: this.$store.state.map.map,
						title: value.label
					});
					this.map.infoWindow = new google.maps.InfoWindow({
						position: latlng,
						// pixelOffset:new google.maps.Size(0, -300),
						content: value.label
					});
					// polyline.block.infoWindow.setPosition(polyline.e.latlng);
					// this.map.infoWindow.open(this.map);
					const map = this.$store.state.map.map;
					searchloc.addListener("click", () => {
					  this.map.infoWindow.open({
					    anchor: searchloc,
					    map,
					    shouldFocus: false,
					  });
					});

					this.$store.commit('map/setSearchLocation', searchloc);
					this.$store.dispatch("map/zoomToSearchLocation", null);
					/*
					icon: {
						className: "user-marker",
						iconUrl: './assets/marker-user.svg',
						iconRetinaUrl: './assets/marker-user.svg',
						iconSize: [40, 40],
						iconAnchor: [30, 30], // iconSize/2 + padding
						shadowUrl: './assets/marker-shadow.svg',
						shadowRetinaUrl: './assets/marker-shadow.svg',
						shadowSize: [40, 40],
						shadowAnchor: [30, 30],
						shadowAngle: 0,
						iconAngle: 0,
						isUserIcon: true
					}
					*/

				}
			}
		},

		debounceStreetSearch(input) {
			let that = this;
			clearTimeout(this.searchTimeout);
			this.searchTimeout = window.setTimeout(function() {
				that.onMapStreetSearch(input);
			}, 500)
		},
		onMapStreetSearch(input) {
			if(input != '') {
				this.isMapStreetsLoading = true;
				Vue.prototype.$httpNoCORS.get(this.$store.state.streetApiUrl + '?stype=lookup3&q='+encodeURI(input))
					.then(res => {
						this.mapStreetOptions = [];
						// var item = {
						// 		id: null,
						// 		label: "Any Street",
						// }
						// this.mapStreetOptions.push(item);
						var item = {
							id: null,
							label: null,
							lat: null,
							lng: null,
						}

						for (var x = 0; x < res.data.searchresult.length; x++) {
								item = {
										id: `${res.data.searchresult[x].linkid}`,
										label: `${res.data.searchresult[x].address}`,
										lat: `${res.data.searchresult[x].lat}`,
										lng: `${res.data.searchresult[x].lon}`
								}
								this.mapStreetOptions.push(item);
						}
						this.isMapStreetsLoading = false;

				})
			}
		},

		onMapStreetSearchAndPreselect(input) {
			if(input != '') {
				var x = 0;
				this.isMapStreetsLoading = true;
				Vue.prototype.$httpNoCORS.get(this.$store.state.streetApiUrl + '?stype=lookup3&q='+encodeURI(input))
					.then(res => {
						this.mapStreetOptions = [];
						var item = {
							id: null,
							label: null,
							lat: null,
							lng: null,
						}

					for (x = 0; x < res.data.searchresult.length; x++) {
								item = {
										id: `${res.data.searchresult[x].linkid}`,
										label: `${res.data.searchresult[x].address}`,
										lat: `${res.data.searchresult[x].lat}`,
										lng: `${res.data.searchresult[x].lon}`
								}
								this.mapStreetOptions.push(item);
						}
						this.isMapStreetsLoading = false;
					for (x = 0; x < this.mapStreetOptions.length ; x++) {
							if (this.mapStreetOptions[x].label == input) {
								this.mapSearchStreet = this.mapStreetOptions[x];
							}
						}
						if (this.mapSearchStreet != null) {
							this.onMapStreetInput(this.mapSearchStreet, null);
						}
				})
			}
		},




		toggleMenu(e, toggle = null) {

			// hide the slide up menu...
			this.slideUpMenu = null;

			// toggle it regardless if its on or off...
			if (e == null && toggle == null) {
				if (this.showMenu == 1) {
					this.showMenu = 0;
				} else {
					this.showMenu = 1;
				}
			} else {
				if (typeof e == "number") {
					this.showMenu = e;
				} else if (typeof e == "boolean") {
					this.showMenu = e;
				} else {
					this.showMenu = toggle ? toggle : !this.showMenu
				}
			}
			Vue.prototype.$menuShown = this.showMenu;
			if (this.showMenu == 0) {
				Vue.prototype.$bus.$emit("menu:hidden", 0);
				this.disableSideMenuOutsideClickMenu = true;
			} else {
				Vue.prototype.$bus.$emit("menu:shown", 1);
				setTimeout(() => {
					if (this.showMenu) {
						this.disableSideMenuOutsideClickMenu = false;
					}
				}, 10);
			}
		},


		clearMap() {
			if (window.location.href.indexOf("new-lane-closure-request") != -1 ||
					window.location.href.indexOf("new-lane-closure-request-with-contravention") != -1 ||
					window.location.href.indexOf("/edit") != -1
				){

				this.infoWindowHtml = "";
				this.infoWindowHtml += "<div class='popup__wrapper'>";
				this.infoWindowHtml += "<div class='popup__block active'>";
				this.infoWindowHtml += this.infoWindowAddBlockHelp();
				this.infoWindowHtml += "<div class='row'>";
				this.infoWindowHtml += "<div class='col'>";
				this.infoWindowHtml += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';

			this.infoWindowHtml += this.infoWindowRemoveAllBlocksButton();

				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";

				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";


			} else {
				this.infoWindowHtml = "";
				this.infoWindowHtml += "<div class='popup__wrapper'>";
				this.infoWindowHtml += "<div class='popup__block active'>";
				this.infoWindowHtml = this.infoWindowSelectRequestBlock();
				this.infoWindowHtml += "<div class='row'>";
				this.infoWindowHtml += "<div class='col'>";
				this.infoWindowHtml += '<a id="globalBusStopMapLink" href="' + this.getMapBoundsBusStopLink() + '" class="btn btn-show-map mb-3" target="_blank">Bus Stop/Parking Lot Map</a>';
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
				this.infoWindowHtml += "</div>";
			}
			this.$store.commit('map/clearMap', null);
		},

		centerMap(e) {
			this.$store.dispatch("map/zoomAllBlocks", null);
		},

		toggleMapFullScreen(e, toggle = null) {
			// toggle it regardless if its on or off...
			if (e == null && toggle == null) {
				if (this.showMapFullScreen == 1) {
					this.showMapFullScreen = 0;
				} else {
					this.showMapFullScreen = 1;
				}
			} else {
				if (typeof e == "number") {
					this.showMapFullScreen = e;
				} else {
					this.showMapFullScreen = toggle ? toggle : !this.showMapFullScreen
				}
			}
			Vue.prototype.$mapShownFullScreen = this.showMapFullScreen;
		},

		exitIfFullScreen() {
			if (this.showMapFullScreen == 1 && this.$store.state.isMobile) {
				this.showMapFullScreen = 0;
				Vue.prototype.$mapShownFullScreen = this.showMapFullScreen;
			}
		},

		hideMapWhenMobile() {
			if (window.getWindowWidth() <= 992) {
				this.showMap = 0;
				Vue.prototype.$mapShown = this.showMap;
				Vue.prototype.$bus.$emit("map:hidden", 0);
			} else {
				this.showMap = 1;
				Vue.prototype.$mapShown = this.showMap;
				Vue.prototype.$bus.$emit("map:shown", 1);
			}
		},
		showMapWhenDesktop() {
			if (window.getWindowWidth() > 992) {
				this.showMap = 1;
				Vue.prototype.$mapShown = this.showMap;
				Vue.prototype.$bus.$emit("map:shown", 1);
			} else {
				this.showMap = 0;
				Vue.prototype.$mapShown = this.showMap;
				Vue.prototype.$bus.$emit("map:hidden", 0);
			}
		},


		toggleBlockPicker(e, toggle = null) {
			// toggle it regardless if its on or off...
			if (e == null && toggle == null) {
				if (this.showBlockPicker == 1) {
					this.showBlockPicker = 0;
				} else {
					this.showBlockPicker = 1;
				}
			} else {
				if (typeof e == "number") {
					this.showBlockPicker = e;
				} else {
					this.showBlockPicker = toggle ? toggle : !this.showBlockPicker
				}
			}
			if (this.showBlockPicker == 0) {
				Vue.prototype.$bus.$emit("map:hidden", 0);
			} else {
				Vue.prototype.$bus.$emit("map:shown", 1);
			}
		},

		toggleSideMap(e, toggle = null) {
			// always turn off main map..
			this.showMap = 0;
			// toggle it regardless if its on or off...
			if (e == null && toggle == null) {
				if (this.showSideMap == 1) {
					this.showSideMap = 0;
				} else {
					this.showSideMap = 1;
				}
			} else {
				if (typeof e == "number") {
					this.showSideMap = e;
				} else {
					this.showSideMap = toggle ? toggle : !this.showSideMap
				}
			}
			Vue.prototype.$mapShown = this.showSideMap;
			if (this.showSideMap == 0) {
				Vue.prototype.$bus.$emit("map:hidden", 0);
			} else {
				Vue.prototype.$bus.$emit("map:shown", 1);
			}
		},

		registerDevice() {
			// let dev = localStorage.getItem("deviceId");
		},

		toggleMap(e, toggle = null) {
			this.showSideMap = 0;
			// toggle it regardless if its on or off...
			if (e == null && toggle == null) {
				if (this.showMap == 1) {
					this.showMap = 0;
				} else {
					this.showMap = 1;
				}
			} else {
				if (typeof e == "number") {
					this.showMap = e;
				} else {
					this.showMap = toggle ? toggle : !this.showMap
				}
			}
			Vue.prototype.$mapShown = this.showMap;
			if (this.showMap == 0) {
				Vue.prototype.$bus.$emit("map:hidden", 0);
			} else {
				Vue.prototype.$bus.$emit("map:shown", 1);
			}
		},

		closeStreetView() {
			// Check if Street View is currently active
			const streetView = this.map.getStreetView();
			if (streetView.getVisible()) {
				// Close Street View
				streetView.setVisible(false);
			}
		},

		toggleMapAndZoom(e, toggle = null) {
			this.showSideMap = 0;
			// toggle it regardless if its on or off...
			if (e == null && toggle == null) {
				if (this.showMap == 1) {
					this.showMap = 0;
				} else {
					this.showMap = 1;
				}
			} else {
				if (typeof e == "number") {
					this.showMap = e;
				} else {
					this.showMap = toggle ? toggle : !this.showMap
				}
			}
			Vue.prototype.$mapShown = this.showMap;

			if (this.showMap == 0) {
				Vue.prototype.$bus.$emit("map:hidden", 0);
			} else {
				let that = this;
				window.setTimeout(function() {
					if (that.map.getZoom() < 16) that.map.setZoom(16);
				}, 250);
				Vue.prototype.$bus.$emit("map:shown", 1);
			}
		},

		toggleSlideUpMenu(e, name) {
			this.slideUpMenu = this.slideUpMenu === name ? null : name
			if (!this.isLoggedIn) {
				return;
			}
			if (name === 'menu') {
				this.toggleMenu(e)
			} else if (this.slideUpMenu === 'requests') {
				this.$store.dispatch('laneClosureList/loadTotal', this.$store.getters['laneClosureList/getParams'])
			} else if (this.slideUpMenu === 'closures') {
				this.$store.dispatch('reportClosureList/loadTotal', this.$store.getters['reportClosureList/getParams'])
			} else if (this.slideUpMenu === 'restrictions') {
				this.$store.dispatch('reportRestrictionList/loadTotal', this.$store.getters['reportRestrictionList/getParams'])
			} else if (this.slideUpMenu === 'contraventions') {
				this.$store.dispatch('reportContraventionList/loadTotal', this.$store.getters['reportContraventionList/getParams'])
			}

			if (['report','viewRequest','actionRequest'].includes(name)) {
				if (document.body.classList.contains('is-ios')) {
					Vue.prototype.$bus.$emit('slideUpMenu:viewLcr:click');
				}
			}

			if (['viewRequestedChanges','actionRequestedChanges'].includes(name)) {
				if (document.body.classList.contains('is-ios')) {
					Vue.prototype.$bus.$emit('slideUpMenu:viewLcr:click');
				}
			}



		},
		hideAllSlideUpMenu() {
			this.slideUpMenu = null;
		},
		goToRequestsList(name) {
			if (name == "newRequest") {
				this.$router.push("/new-lane-closure-request?r=" + Math.round(Math.random() * Math.pow(10, 6)));
			} else {
				// always show the first page of results when setting parameters
				this.$store.dispatch('laneClosureList/clearStatusFilters');
				this.$store.dispatch('laneClosureList/updateParams', { approvalStatusId: null })
				this.$store.dispatch('laneClosureList/updateParams', { closureActiveStatusId: null })
				this.$store.dispatch('laneClosureList/updateParams', { restrictionActiveStatusId: null })
				this.$store.dispatch('laneClosureList/updateParams', { hasClosures: null })
				this.$store.dispatch('laneClosureList/updateParams', { hasRestrictions: null })
				this.$store.dispatch('laneClosureList/updateParams', { page: 1 });
				if (name == "all") {
					// don't change any of the status filters.
					this.$router.push("/lane-closure-request-list?r=" + Math.round(Math.random() * Math.pow(10, 6)));
				} else {
					// Requests with Approval Status
					let callOptionMethod = this.$store.getters['laneClosureList/getGrid'][0].statusLookup
					if (callOptionMethod) {
						let result = Format.searchByKeyInArray(name, 'filter', LaneClosureRequest[callOptionMethod])
						if (result) {
							this.$store.dispatch('laneClosureList/updateParams', { approvalStatusId: result ? result.id : null }).then(() => {
								this.$router.push("/lane-closure-request-list?r=" + Math.round(Math.random() * Math.pow(10, 6)));
							});
						}
					}
				}
			}
		},
		goToClosuresList(name) {
			// always show the first page of results when setting parameters
			this.$store.dispatch('reportClosureList/updateParams', { page: 1, closureActiveStatusId: null, hasClosures: 1 }).then(() => {
				if (name) {
					if (name == "all") {
						// no need to change the parameters.
						this.$router.push("/report-lane-closure?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					}
					if (name == "newEmergency") {
						this.$router.push("/new-lane-closure-request?isEmergency=1&r=" + Math.round(Math.random() * Math.pow(10, 6)));
					}
					if (name == "planned") {
						this.$store.dispatch('reportClosureList/updateParams', { closureActiveStatusId: 1 }).then(() => {
							this.$router.push("/report-lane-closure?r=" + Math.round(Math.random() * Math.pow(10, 6)));
						});
					}
					if (name == "active") {
						this.$store.dispatch('reportClosureList/updateParams', { closureActiveStatusId: 2 }).then(() => {
							this.$router.push("/report-lane-closure?r=" + Math.round(Math.random() * Math.pow(10, 6)));
						});
					}
					if (name == "expired") {
						this.$store.dispatch('reportClosureList/updateParams', { closureActiveStatusId: 3 }).then(() => {
							this.$router.push("/report-lane-closure?r=" + Math.round(Math.random() * Math.pow(10, 6)));
						});
					}
				}
			});
		},
		goToRestrictionsList(name) {
			// always show the first page of results when setting parameters
			this.$store.dispatch('reportRestrictionList/updateParams', { page: 1, restrictionActiveStatusId: null, hasRestrictions: 1 });
			if (name) {
				if (name == "all") {
					// no need to change the parameters.
					this.$router.push("/report-restriction?r=" + Math.round(Math.random() * Math.pow(10, 6)));
				}
				if (name == "newEmergency") {
					this.$router.push("/new-lane-closure-request?isEmergency=1&r=" + Math.round(Math.random() * Math.pow(10, 6)));
				}
				if (name == "planned") {
					this.$store.dispatch('reportRestrictionList/updateParams', { restrictionActiveStatusId: 1 }).then(() => {
						this.$router.push("/report-restriction?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					});
				}
				if (name == "active") {
					this.$store.dispatch('reportRestrictionList/updateParams', { restrictionActiveStatusId: 2 }).then(() => {
						this.$router.push("/report-restriction?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					});
				}
				if (name == "expired") {
					this.$store.dispatch('reportRestrictionList/updateParams', { restrictionActiveStatusId: 3 }).then(() => {
						this.$router.push("/report-restriction?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					});
				}
			}
		},
		goToContraventionsList(name) {
			this.$store.dispatch('reportContraventionList/updateParams', { approvalStatusId: null })
			this.$store.dispatch('reportContraventionList/updateParams', { page: 1 });
			this.$store.dispatch('reportContraventionList/updateParams', { needsNewContravention: null });
			this.$store.dispatch('reportContraventionList/updateParams', { hasContraventions: null });

			if (name == "newContravention") {
				this.$router.push({name:"AddLaneClosureRequestWithContravention"});
				return;
			}
			if (name == "all") {
				// no need to change the parameters.
				this.$router.push("/report-contravention?r=" + Math.round(Math.random() * Math.pow(10, 6)));
				return;
			}

			if (name) {
				if (name == "expired") {
					this.$store.dispatch('reportContraventionList/updateParams', { needsNewContravention: 1 }).then(() => {
						this.$router.push("/report-contravention?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					});
				}
				if (name == "with") {
					this.$store.dispatch('reportContraventionList/updateParams', { hasContraventions: 1 }).then(() => {
						this.$router.push("/report-contravention?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					});
				}
				if (name == "without") {
					this.$store.dispatch('reportContraventionList/updateParams', { hasContraventions: 0 }).then(() => {
						this.$router.push("/report-contravention?r=" + Math.round(Math.random() * Math.pow(10, 6)));
					});
				}
			}
		},

		onStatusUpdate(name) {
			if (this.slideUpMenu == "requests") {
				this.goToRequestsList(name);
			}
			if (this.slideUpMenu == "closures") {
				this.goToClosuresList(name);
			}
			if (this.slideUpMenu == "restrictions") {
				this.goToRestrictionsList(name);
			}
			if (this.slideUpMenu == "contraventions") {
				this.goToContraventionsList(name);
			}
			this.slideUpMenu = null
		},

		onReportMenu(name) {
			if (name == "reportClosure") {
				this.goToReportClosure();
			}
			if (name == "reportRestriction") {
				this.goToReportRestriction();
			}
			if (name == "reportViolation") {
				this.$router.push({ name: "ReportContravention", params: { id: this.$route.params.id } });
			}
			this.slideUpMenu = null;
		},

		markAsCompleted() {
			this.showCompleteRequestModal();
			if (this.canCompleteRequest()) {
				// this.showCompleteRequestModal();
			}
		},

		onActionRequestMenu(name) {
			if (name == "actionViewRequestedChanges") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/view-requested-changes?r=" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "actionRequestComplete") {
				this.showCompleteRequestModal();
			}
			if (name == "actionRequestEdit") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/edit?r=" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "actionRequestCancel") {
				this.showCancelRequestModal();
			}
			if (name == "actionRequestReportViolation") {
				this.$router.push({ name: "ReportContravention", params: { id: this.$route.params.id } });
			}
			if (name == "actionRequestDuplicate") {
				this.$router.push({ name: "DuplicateLaneClosureRequest", params: { id: this.$route.params.id } });
			}
			this.slideUpMenu = null
		},
		onActionRequestedChangesMenu(name) {

			if (name == "actionRequestedChangesBack") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/view/" + Math.round(Math.random() * Math.pow(10, 6)));
			}


			if (name == "actionRequestedChangesDiscard") {
				this.showDiscardChangeRequestModal();
			}
			if (name == "actionRequestedChangesEdit") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/edit-requested-changes?r=" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			this.slideUpMenu = null
		},

		onViewRequestMenu(name) {
			/*
			requestDetails
			requestAttachments
			requestViolations
			requestActivity
			*/
			if (name == "requestDetails") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/view/" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "requestAttachments") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/attachments/" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "requestViolations") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/contraventions/" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "requestActivity") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/activity/" + Math.round(Math.random() * Math.pow(10, 6)));
			}

			if (name == "requestContacts") {
				Vue.prototype.$bus.$emit("request:showContacts", null);
			}
			this.slideUpMenu = null
		},


		onViewRequestedChangesMenu(name) {
			/*
			requestDetails
			requestAttachments
			requestViolations
			requestActivity
			*/
			if (name == "requestDetails") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/view/" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "requestAttachments") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/attachments/" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "requestViolations") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/contraventions/" + Math.round(Math.random() * Math.pow(10, 6)));
			}
			if (name == "requestActivity") {
				this.$router.push("/lane-closure-request/"+this.$route.params.id+"/activity/" + Math.round(Math.random() * Math.pow(10, 6)));
			}

			if (name == "requestContacts") {
				Vue.prototype.$bus.$emit("request:showContacts", null);
			}
			this.slideUpMenu = null
		},

		OnSideMenuClose() {
			this.toggleMenu(false);
		},
		secretTesting(event) {
			if (this.$store.state.swapUrl != "") {
				this.showTestingCounter++;
				if (this.showTestingCounter >= 6) {
			this.toggleMenu(false);
					this.showTestingModal = true;
					this.showTestingCounter = 0;
				} else {
					event.preventDefault();
				}
			}
		},
		showProcessSwapName() {
			if (process) {
				return this.$store.state.swapName;
			}
		},
		onConfirmTesting() {
			if (process) {
				if (this.$store.state.swapUrl != "") {
					this.showTestingModal = false;
					window.location.href = this.$store.state.swapUrl;
				}
			}
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;

			if (this.window.width <= 992) {
				this.disableSideMenuOutsideClickWindow = false;
			} else {
				this.disableSideMenuOutsideClickWindow = true;
			}
		},
		logout: function() {
			Vue.prototype.$bus.$emit("map:toggle", 0);
			// this.$store.dispatch('logout')
			// .then(() => {
			// 	// this.$router.push('/login')
			// 	this.$router.replace('/login')
			// })

			// Logout making use of logout requested in the vuex
			this.$store.commit('logoutRequested', true);
			this.$router.replace('/login');
		},

		async getTotals() {
			if (!this.isLoggedIn) {
				return;
			}

			let lcrQuery = JSON.parse(localStorage.getItem('lcrArgs'))
			if (lcrQuery) {
				this.$store.dispatch('laneClosureList/updateParams', { page: 1 } );
				this.$store.dispatch('laneClosureList/updateParams', lcrQuery );
			}

			let rcQuery = JSON.parse(localStorage.getItem('closureArgs'))
			if (rcQuery) {
				this.$store.dispatch('reportClosureList/updateParams', { page: 1 } );
				this.$store.dispatch('reportClosureList/updateParams', rcQuery );
			}

			let rrQuery = JSON.parse(localStorage.getItem('restrictionArgs'))
			if (rrQuery) {
				this.$store.dispatch('reportRestrictionList/updateParams', { page: 1 } );
				this.$store.dispatch('reportRestrictionList/updateParams', rrQuery )
			}

			let cQuery = JSON.parse(localStorage.getItem('contraventionArgs'))
			if (cQuery) {
				this.$store.dispatch('reportContraventionList/updateParams', { page: 1 } );
				this.$store.dispatch('reportContraventionList/updateParams', cQuery )
			}
			// console.log("lane loadTotal");
			await this.$store.dispatch('laneClosureList/loadTotal', this.$store.getters['laneClosureList/getParams'])
			// console.log("lane reportClosureList");
			await this.$store.dispatch('reportClosureList/loadTotal', this.$store.getters['reportClosureList/getParams'])
			// console.log("lane reportRestrictionList");
			await this.$store.dispatch('reportRestrictionList/loadTotal', this.$store.getters['reportRestrictionList/getParams'])
			// console.log("lane reportContraventionList");
			await this.$store.dispatch('reportContraventionList/loadTotal', this.$store.getters['reportContraventionList/getParams'])

		},


		initSignalR() {
			this.$lcrHub.$on('new-notification', this.newNotification)
			this.$lcrHub.$on('dismiss-notification', this.dismissNotification)
			this.$lcrHub.$on('dismiss-contravention-notification', this.dismissContraventionNotification)
		},

		clickOutsideNotificationDisplay(e) {
			let notificationWindow = document.getElementById('popover-updates');
			if (this.showMessageTab == true) {
				notificationWindow = document.getElementById('popover-messages');
			}
			// let notificationBell = document.getElementById('notification-bell-icon');
			let laneFilterMessageButton = document.getElementById('list-filter-messages-button');
			let laneFilterUpdateButton = document.getElementById('list-filter-updates-button');
			let keepOpen = false;
			if (notificationWindow) {

				if (notificationWindow.contains(e.target)) {
					keepOpen = true;
				}
				// if (notificationBell.contains(e.target)) {
				// 	keepOpen = true;
				// }
				if (laneFilterMessageButton) {
					if (laneFilterMessageButton.contains(e.target)) {
						keepOpen = true;
					}
				}
				if (laneFilterUpdateButton) {
					if (laneFilterUpdateButton.contains(e.target)) {
						keepOpen = true;
					}
				}
				if (!keepOpen) {
					this.hideNotificationDetail();
				}
			}


		},



		newNotification(entry) {
			this.showNotification(entry);
			Vue.prototype.$bus.$emit("notification:refresh", 0);
		},

		showNotification(entry) {
			// let that = this;

			/*
			if (['lcr-new-message', 'lcr-change-request', 'contravention-new-message'].includes(entry.notificationTypeId)) {
				this.messageNotifications.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) this.messageNotificationsCount++;
			} else {
				this.updateNotifications.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) this.updateNotificationsCount++;
			}
			*/
			this.$store.dispatch('notificationList/addNotification', entry).then(() => {
				this.messageNotifications = this.$store.getters['notificationList/messages'];
				this.updateNotifications = this.$store.getters['notificationList/updates'];
				this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
				this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
				Vue.prototype.$bus.$emit("notification:refresh");
			});
		},


		dismissContraventionNotification(contraventionId) {
			this.$store.dispatch('notificationList/dismissContraventionNotification', contraventionId).then(() => {
				this.messageNotifications = this.$store.getters['notificationList/messages'];
				this.updateNotifications = this.$store.getters['notificationList/updates'];
				this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
				this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
				Vue.prototype.$bus.$emit("notification:refresh");
			});
		},


		dismissNotification(lcrId) {
			this.$store.dispatch('notificationList/dismissNotification', lcrId).then(() => {
				this.messageNotifications = this.$store.getters['notificationList/messages'];
				this.updateNotifications = this.$store.getters['notificationList/updates'];
				this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
				this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
				Vue.prototype.$bus.$emit("notification:refresh");

			});

			// this.messageNotifications.forEach(x => {
			// 	if (x.lcrId == lcrId) {
			// 		x.isRead = 1;
			// 		this.messageNotificationsCount--;
			// 	}
			// });
			// this.updateNotifications.forEach(x => {
			// 	if (x.lcrId == lcrId) {
			// 		x.isRead = 1;
			// 		this.updateNotificationsCount--;
			// 	}
			// });
		},
		toggleMessages() {
			if (this.showNotifications == true && this.showMessageTab == false) {
				this.showMessageTab = true;
			} else {
				this.showMessageTab = true;
				this.toggleNotificationMessagesDetail();
			}
		},
		toggleUpdates() {
			if (this.showNotifications == true && this.showMessageTab == true) {
				this.showMessageTab = false;
			} else {
				this.showMessageTab = false;
				this.toggleNotificationMessagesDetail();
			}
		},


		toggleNotificationMessagesDetail() {
			this.showNotifications = !this.showNotifications
			this.$nextTick(() => {
				if (this.showNotifications) {
					window.addEventListener('click', this.clickOutsideNotificationDisplay);
				}
				else {
					window.removeEventListener('click', this.clickOutsideNotificationDisplay);
				}
			});
		},

		toggleNotificationDetail() {
			this.showNotifications = !this.showNotifications
			this.$nextTick(() => {
				if (this.showNotifications) {
					window.addEventListener('click', this.clickOutsideNotificationDisplay);
				}
				else {
					window.removeEventListener('click', this.clickOutsideNotificationDisplay);
				}
			});
		},
		hideNotificationDetail() {
			if (this.showNotifications) {
				this.showNotifications = false;
				window.removeEventListener('click', this.clickOutsideNotificationDisplay);
			}
		},

		goToNotificationDest(notification) {
			if (notification.lcrId) {
				if (notification.notificationTypeId == 'new-contravention') {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view-contravention/${notification.entityId}`);
				} else if ( notification.notificationTypeId == 'contravention-new-message') {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view-contravention/${notification.contraventionId}`);
				} else {
					this.$router.push(`/lane-closure-request/${notification.lcrId}/view`);
				}
			}

			this.showNotifications = false;
		},

		getUnreadNotifications() {
			if (!this.isLoggedIn) {
				return;
			}
			let that=this;

			if (this.loadingNotifications) {
				return;
			}
			this.loadingNotifications = true;
			this.$store.dispatch('notificationList/load').then(() => {
			/*
				if (res.data.notifications) {
					this.messageNotifications = [];
					this.updateNotifications = [];
					this.messageNotificationsCount = 0;
					this.updateNotificationsCount = 0;
					res.data.notifications.forEach(x => this.showNotification(x));
				}
				*/
				that.messageNotifications = that.$store.getters['notificationList/messages'];
				that.updateNotifications = that.$store.getters['notificationList/updates'];
				that.messageNotificationsCount = that.$store.getters['notificationList/unreadMessagesCount'];
				that.updateNotificationsCount = that.$store.getters['notificationList/unreadUpdatesCount'];
				Vue.prototype.$bus.$emit("notification:refresh");
				this.loadingNotifications = false;
			})
		},

		getNotificationBubbleColor(entry) {
			if (entry.readDate || entry.isRead == 1) {
				return '#eeeeee';
			} else {
				return '#293c7c';
			}
		},

		clearAllClick(type) {
			if (type == "messages") {
				this.$store.dispatch('notificationList/dismissAllMessageNotification', type)
				.then(() => {
					this.messageNotifications = this.$store.getters['notificationList/messages'];
					this.updateNotifications = this.$store.getters['notificationList/updates'];
					this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
					this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
					Vue.prototype.$bus.$emit("notification:refresh");
				});
			} else {
				this.$store.dispatch('notificationList/dismissAllUpdateNotification', type)
				.then(() => {
					this.messageNotifications = this.$store.getters['notificationList/messages'];
					this.updateNotifications = this.$store.getters['notificationList/updates'];
					this.messageNotificationsCount = this.$store.getters['notificationList/unreadMessagesCount'];
					this.updateNotificationsCount = this.$store.getters['notificationList/unreadUpdatesCount'];
					Vue.prototype.$bus.$emit("notification:refresh");
				});
			}
		},

		openLoginExpire() {
			this.showLoginExpire = true;
		},
		redirectToLogin() {
			let that = this;
			this.showLoginExpire = false;
			this.$store.dispatch("logout").then(function() {
				if (that.$router) {
					that.$router.replace({path: "login", params: {from: that.$route.fullPath}});
				} else {
					window.location.href = "/login?r="+Math.random();
				}
			});

			// this.$router.push({path: "login", params: {from: this.$route.fullPath}});
		},

		initMenuClickEvent() {
			document.addEventListener("touchstart", this.menuClick);
		},
		menuClick(e) {
            let target = e.target;
			let menus = document.getElementsByClassName("slide-up-menu");
			let menusGroups = document.getElementsByClassName("slide-up-menu-group");
			let clickedOnMenu = false;
			for (let i = 0; i < menus.length; i++) {
				if (menus[i].contains(target)) {
					clickedOnMenu = true;
				}
			}
			if (!clickedOnMenu) {
				for (let i = 0; i < menusGroups.length; i++) {
					if (menusGroups[i].contains(target)) {
						clickedOnMenu = true;
					}
				}
			}

			if (!clickedOnMenu) {
				this.slideUpMenu = null;
			}
        },

		clickSideMenuLink(e) {
			this.showMenu = false;
		},
	},
	destroyed() {
	    Vue.prototype.$bus.$off('keyboard:willShow', this.onKeyboardWillShow);
	    Vue.prototype.$bus.$off('keyboard:didShow', this.onKeyboardDidShow);
	    Vue.prototype.$bus.$off('keyboard:willHide', this.onKeyboardWillHide);
	    Vue.prototype.$bus.$off('keyboard:didHide', this.onKeyboardDidHide);
	},
	created: function() {

		Vue.prototype.$bus.$on('keyboard:willShow', this.onKeyboardWillShow);
		Vue.prototype.$bus.$on('keyboard:didShow', this.onKeyboardDidShow);
		Vue.prototype.$bus.$on('keyboard:willHide', this.onKeyboardWillHide);
		Vue.prototype.$bus.$on('keyboard:didHide', this.onKeyboardDidHide);

		let that = this;

		window.popupRequest = function(id) {
			that.$store.dispatch("map/panToNearbyLaneClosureRequestId", id);
			/*
			Vue.prototype.$bus.$emit('map:block-popup', {
				polyline: that.$store.getters["map/polylines"][id],
				e:that.popupE
			});
			*/
		}

		window.popupOverlapRequest = function(index) {
			Vue.prototype.$bus.$emit('map:overlap-block-popup', {
				index:index,
				e:that.popupE
			});
		}


		// window.goToBlockTab = function(id) {
		// 	Vue.prototype.$bus.$emit('map:block-popup', {
		// 		polyline: that.$store.getters["map/polylines"][id],
		// 		e:that.popupE
		// 	});
		// }

		// window.goToNearbyBlockTab = function(id) {
		// 	Vue.prototype.$bus.$emit('map:nearby-block-popup', {
		// 		polyline: that.$store.getters["map/nearbyPolylines"][id],
		// 		e:that.popupE
		// 	});

		// }
		window.getBusMapUrl = function() {
			return that.getMapBoundsBusStopLink();
		}

		window.getBusStopMapLink = function(id) {
			let comma = "";
			let link = that.$store.state.busStopMapUrl + "&ll=";
			let foundBoundaries = false;
			for (var x =0; x < that.$store.getters["map/polylines"].length; x++) {
				if (that.$store.getters["map/polylines"][x].id == id) {
					let polyBounds = that.$store.getters["map/polylines"][x].getPath();
					for (var z = 0; z < polyBounds.length; z++) {
						link += comma+polyBounds.getAt(z).lat()+"%2c"+polyBounds.getAt(z).lng();
						foundBoundaries = true;
						break;
					}
					break;
				}
			}
			if (foundBoundaries) {
				link += "&z=18";
				return link;
			}
			return null;
		},

		window.goToLaneClosureRequestId = function(id) {
			Vue.prototype.$bus.$emit("map:hideWhenMobile", 0);
			that.$router.push("/lane-closure-request/" + id + "/view");
		}
		window.hideMapPopup = function(id) {
			if (that.map.infoWindow) {
				that.map.infoWindow.setMap(null);
			}
		}

		window.removeBlockId = function(id) {
			if (that.map.infoWindow) {
				that.map.infoWindow.setMap(null);
			}
			that.infoWindowHtml = that.infoWindowAddBlockHelp();

			var html = ""
			html += "<div class='row'>";
			html += "<div class='col'>";
			html += that.infoWindowRemoveAllBlocksButton();
			html += "</div>";
			html += "</div>";


			that.infoWindowHtml += html;
			Vue.prototype.$bus.$emit("map:block-remove", id);
		}

		window.removeAllBlocks = function() {
			/*
			if (that.map.infoWindow) {
				that.map.infoWindow.setMap(null);
			}
			that.infoWindowHtml = that.infoWindowAddBlockHelp();
			*/
			Vue.prototype.$bus.$emit("map:block-remove-all");
		}


		window.getWindowSize = function() {
			var d = document,
			root = d.documentElement,
			body = d.body;
			var wid = window.innerWidth || root.clientWidth || body.clientWidth,
			hi = window.innerHeight || root.clientHeight || body.clientHeight;
			return [wid, hi]
		}
		window.getWindowWidth = function() {
			var d = document,
			root = d.documentElement,
			body = d.body;
			var wid = window.innerWidth || root.clientWidth || body.clientWidth;
			return wid;
		}
		window.getWindowHeight = function() {
			var d = document,
			root = d.documentElement,
			body = d.body;
			var hi = window.innerHeight || root.clientHeight || body.clientHeight;
			return hi;
		}

		/*
			this.restoreContext();
		this.$http.interceptors.response.use(undefined, function (error) {
			return new Promise(function (resolve, reject) {
				if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
					this.$store.dispatch('logout')
				}
				throw error;
			})
		})
		*/
	}
}

</script>